import { Component, OnInit, OnChanges, Input, Renderer2, ViewChild, ElementRef, VERSION } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { DataTableDirective } from 'angular-datatables';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { AgendaService } from '../../../services/agenda.service';
import { environment } from '../../../../environments/environment';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Rx';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonFunction } from '../../../helpers/commonFunction';


import { TaskService } from '../../../services/task.service';
import { findIndex } from 'rxjs/operators/findIndex';
import { CustomValidation } from "../../../helpers/customValidation";
import { UserMasterService } from '../../../services/user-master.service';


declare var $: any;
declare var jQuery: any;
import * as _ from 'lodash';
import { GroupMasterService } from 'src/app/services/group-master.service';
import { AlertComponent } from '../../alert/alert.component';
import { CategoryMasterService } from 'src/app/services/category-master.service';
import { ProcessMasterService } from 'src/app/services/process-master.service';
import { BranchAndDepartmentService } from 'src/app/services/branch-and-department.service';
import { MeetingMasterService } from 'src/app/services/meeting-master.service';

@Component({
  selector: 'app-libraryagenda-edit',
  templateUrl: './libraryagenda-edit.component.html',
  styleUrls: ['./libraryagenda-edit.component.css']
})
export class LibraryagendaEditComponent implements OnInit {

  showOptionLable: string = "show More Option";
  agendaAddForm: FormGroup;
  imageAdd: boolean
  imageAddRev: boolean;
  imageEdit: boolean = false;
  minuteDocAdd: boolean;
  minuteDocEdit: boolean;
  minuteDocAddRev: boolean = false;
  meetingType: any[];
  meetingTypes: any[];
  categories: any[];
  preDefinedTask: any[];
  preDefinedTasknew: any[];
  IsSelectedUpload: any;
  fileUpload: any;
  environmentSettings: any;
  name: any;
  reader: any;
  filesToUpload: Array<File>;
  changedName: any = "";
  FileOrignalName: any;
  currentURL: any;
  isClickedOnce = false;
  agendaId: any;
  IscategorySelected123: any;
  IsMeetingAssigned123: any;
  isLibraryAgenda: any;
  isCategoryGlobal: boolean;
  companyNameData: any = [];
  pushCompanyDataId = [];
  uploadAgendaDocFileBtn: boolean = true;

  selectedAll: any;
  IsSelectedTasks: any;
  companytasklist: any[];
  agendaAddedTaskList: any[] = undefined;
  processes: any[];
  addedProcess: any[];
  deletedTasks: any[];
  deletedProcesses: any[];
  disabledOnclick: boolean = false;
  agendaFiles = [];
  documentArr = [];
  token: any = localStorage.getItem('token')
  AddNewAgendafiles: boolean = false;
  MinDocFiles = [];
  documentArrMinDoc = [];
  TotalFileMinDoc: any = [{}];
  indexGroupingList: any;
  public departmentList: any = [];
  public agendaTypeOption: any = [];
  agendaNameFieldTouched: boolean;

  GroupingIndex: any;
  GroupingName: any;
  GroupingNumber: any;
  groupName: any;
  groupNumber: any;
  fileExtension: boolean = true;
  categoryIdForEdit: any;
  categoryNameForEdit: any;
  isPSSMasterAgenda: boolean;
  meetingTypeID: any;

  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptionsTaskAddingPopup: DataTables.Settings = {};
  dtTriggerTaskAddingPopup: Subject<any> = new Subject();

  dtOptionsForAddedTask: DataTables.Settings = {};
  dtTriggerForAddedTask: Subject<any> = new Subject();

  dtOptionsForAddedProcess: DataTables.Settings = {};
  dtTriggerForAddedProcess: Subject<any> = new Subject();

  dtOptionsProcessAddingPopup: DataTables.Settings = {};
  dtTriggerProcessAddingPopup: Subject<any> = new Subject();

  groupTypes: any[];
  groupID: any;
  SearchtaskEventbasedorPeriodicModel: any;
  SearchtaskUserdefinedorPredefinedModel: any;

  documentsDownload: any[];
  actualFileName: any[];
  TotalFile: any = [{}];
  orignalName: string;
  filenamedit: any;
  filenameoriginal: any;
  filesToUploadMinuteDocument: Array<File>;
  FileChangedName: any = new Array();
  FileNameOrignalDisplay: any = new Array();
  FileOrignalNameMinDoc: any;

  FileChangedNameMinDoc: any = new Array();
  FileUnchangedNameMinDoc: any = new Array();
  FileNameOrignalDisplayMinDoc: any = new Array();
  documentsDownloadMinute: any;
  minutesDocId: any;

  previousAgendafilename: any;
  previousAgendafileoriginal: any;
  GroupingNumberTouched: boolean;
  GroupingNameTouched: boolean;

  public downloadSingleFile: string;

  public downloadAllLink: string;
  public downloadLink: string;
  public loading = false;

  PreambleAndResolution_DocId: any;


  constructor(private customValidation: CustomValidation,
    private groupMasterService: GroupMasterService,
    private taskService: TaskService,
    private alert: AlertComponent,
    private router: Router,
    private route: ActivatedRoute,
    private rd: Renderer2,
    private categoryMasterService: CategoryMasterService,
    private agendaService: AgendaService,
    private processMasterService: ProcessMasterService,
    private commonFunction: CommonFunction,
    private activatedRoute: ActivatedRoute,
    private userMasterService: UserMasterService,
    private meetingService: MeetingMasterService,
    private branchAndDepartmentService: BranchAndDepartmentService
  ) {

    this.name = `Angular v${VERSION.full} : File Upload`
    this.filesToUpload = [];
    this.currentURL = window.location.href;
    this.filesToUploadMinuteDocument = [];
  }

  catBoolean: boolean;
  meetingBoolean: boolean;
  categoryMasterForm: FormGroup;
  taskFormControl: FormGroup;
  ActualDataToAgenda: any[];
  PageTitle: any;

  meetingIdForDownload = '';


  ngOnInit() {

    this.downloadAllLink = environment.pssUIBaseUrl + 'meeting/downloadAllAsZip/';
    this.downloadLink = environment.pssUIBaseUrl + 'meeting/downloadIndividual/';
    this.environmentSettings = environment;

    $('.modal-dialog').draggable({
      handle: ".modal-header"
    });

    this.regiserModalShowEvent();
    // this.getGroupIndex();
    this.SearchtaskEventbasedorPeriodicModel = '1'
    this.dtOptionsTaskAddingPopup = {
      destroy: true,
      scrollY: "250px",
      scrollX: true,
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      stateSave: true,
      stateDuration: -1,
      search: true,
      searching: true,
      order: [1, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [0] }],
    };
    this.dtOptionsForAddedTask = {
      destroy: true,
      scrollY: "250px",
      scrollX: true,
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      stateSave: true,
      stateDuration: -1,
      search: false,
      searching: false,
      order: [1, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [4] }],
    };
    this.dtOptionsForAddedProcess = {
      destroy: true,
      scrollY: "250px",
      scrollX: true,
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      stateSave: true,
      stateDuration: -1,
      search: false,
      searching: true,
      order: [1, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [3] }],
    };
    this.dtOptionsProcessAddingPopup = {
      destroy: true,
      scrollY: "250px",
      scrollX: true,
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      stateSave: true,
      stateDuration: -1,
      search: false,
      searching: true,
      order: [1, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [0] }],
    };

    this.booleanMeetingValidate = false;
    this.booleanCategoryValidate = false;
    this.catBoolean = false;
    this.meetingBoolean = false;


    this.getMeetingTypeList();
    this.getCategoryList();
    this.agendaAddForm = new FormGroup({
      agendaNumber: new FormControl('', [Validators.required]),
      agendaNumberPrefix: new FormControl('', []),
      IscategorySelected: new FormControl('', [Validators.required]),//added Field
      IsMeetingAssigned: new FormControl('', [Validators.required]),//added Field
      meetingType: new FormControl('', [Validators.required]),
      selectCategory: new FormControl('', []),//Modified added field
      meeting: new FormControl('', []),// added field
      agendaTitle: new FormControl('', [Validators.required, this.customValidation.noWhitespaceValidator]),
      agendaType: new FormControl('', []),
      department: new FormControl('', []),
      agendaCompliance: new FormControl('', []),
      name: new FormControl('', []),
      image: new FormControl('', []),
      imageMinDoc: new FormControl('', []),
      indexGrouping_id: new FormControl('', [])
    });

    var lastSegOfURL = window.location.href.substr(window.location.href.lastIndexOf('/') + 1)

    if (this.currentURL.includes('edit')) {
      this.imageAdd = false;
      this.imageAddRev = false
      this.imageEdit = true;
      this.minuteDocEdit = true;
      this.minuteDocAdd = false;
      this.minuteDocAddRev = false;
      this.branchAndDepartmentService.getDepartment().subscribe((response:any) => {
        if (response.status == 0) {
          this.departmentList = response.data;
          this.getFormDetaisOnEdit();
          this.getpredefinedTaskList();
          $("#saveBtnAgenda").hide();
          $("#editBtnAgenda").show();
          this.getCompanyTaskListInUpdateAgenda();
        }
        // this.departmentList = response.data;
      })
      this.agendaService.getGroupIndex().subscribe(data => {
        console.log('data', data)

        if (data.status == 0) {
          this.indexGroupingList = data.data;
          this.getFormDetaisOnEdit();
          this.getpredefinedTaskList();
          $("#saveBtnAgenda").hide();
          $("#editBtnAgenda").show();
          this.getCompanyTaskListInUpdateAgenda();
        }
      });

    } else {

      this.addedProcess = [];
      this.dtTriggerForAddedProcess.next();
      this.PageTitle = "Add Agenda"
      $('#addedtaskTable').DataTable({
        "searching": false,
        "lengthMenu": [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
        "columnDefs": [{ orderable: false, targets: [4] }],
        "language": {
          "emptyTable": "No data available in table"
        }
      });
      this.imageAddRev = false;
      $("#saveBtnAgenda").show();
      $("#editBtnAgenda").hide();
      this.getpredefinedTaskList();
      this.imageAdd = true;
      this.imageEdit = false;
      this.minuteDocAdd = true;
      this.minuteDocEdit = false;
      this.agendaAddForm.reset();
      this.agendaAddForm.controls.IsMeetingAssigned.setValue("No");
      this.agendaAddForm.controls.IscategorySelected.setValue("No");
      this.getCompanyTaskList();
    }
    // console.log(this.imageAdd);
    this.categoryMasterForm = new FormGroup({
      CategoryName: new FormControl('', [Validators.required, Validators.maxLength(100), Validators.pattern("^[a-zA-Z0-9][a-zA-Z0-9 _@./$!#%&,()+-]*$")
      ]),
      IsGlobal: new FormControl('', [Validators.required]),
      isDefault: new FormControl('', [Validators.required]),
      MeetingType: new FormControl('', [Validators.required])
    });

    this.getGroupmasterList();


    this.preSelectedMeetingToAdd();

    // this.getProcessList()

    $("#agendaTitle").focus();
  }
  FromMeetingmeetingID: any;
  FromMeetingmeetingTypeID: any;

  preSelectedMeetingToAdd() {

    var obj = JSON.parse(localStorage.getItem('queryParams'));
    if (obj) {
      this.FromMeetingmeetingID = obj[0].meetingID;
      this.FromMeetingmeetingTypeID = obj[0].meetingTypeID;
      this.getMeetingFromType(obj[0].meetingTypeID)
      this.agendaAddForm.controls.meetingType.setValue(obj[0].meetingTypeID);
      this.agendaAddForm.controls.meeting.setValue(obj[0].meetingID);
      this.agendaAddForm.controls.IsMeetingAssigned.setValue('Yes');
      this.CheckAssignMeeting('Yes')
      console.log('Meeting ID ', this.FromMeetingmeetingID);
      console.log('Meeting TypeID', this.FromMeetingmeetingTypeID);
    }


    //  localStorage.removeItem('queryParams')
  }
  //remove added Data from popup list
  // console.log('availableData--->>>',this.agendaAddedTaskList);
  // console.log('all data------->>>',this.companytasklist);
  // this.agendaAddedTaskList.forEach(element => {
  //       var removeflag=true;
  //   for(var i=0;i<this.companytasklist.length;i++){
  //       if(element.Task_id==this.companytasklist[i].ID){
  //         console.log('Available Data',element.Task_id);
  //       }
  //  }
  // });
  // gettaskListOnAddClick() {
  //   var table2 = $('#companytaskTable').DataTable({ destroy: true });
  //   table2.destroy();
  //   this.taskService.getCompanyTaskList()
  //     .subscribe(taskList => {
  //       var data = []
  //       if (taskList.status == 0) {
  //         data = taskList.tasksDatalist.TasksData;
  //         if (this.agendaAddedTaskList != undefined) {

  //           for (var i = 0; i < data.length; i++) {
  //             var flag = true;
  //             for (var j = 0; j < this.agendaAddedTaskList.length; j++) {
  //               if (data[i].ID == this.agendaAddedTaskList[i].Task_id) {
  //                 flag = false;
  //                 break;
  //               }
  //             }
  //             if (flag) {
  //               this.companytasklist.push(data[i]);
  //             }
  //           }
  //         }
  //       }
  //     });
  // }


  getCompanyTaskList() {
    var table2 = $('#companytaskTable').DataTable({ destroy: true });
    table2.destroy();
    this.companytasklist = [];
    var companytaskWithAddedToShow = []
    var unique = []
    var data = [];
    this.taskService.getCompanyTaskList()
      .subscribe(taskList => {

        let checked = true;
        if (taskList.status == 0) {
          //var predefinedTaskList = $(taskList.tasksDatalist.TasksData).filter(function (i, n) { return n.TriggerType==1 });

          companytaskWithAddedToShow = taskList.tasksDatalist.TasksData;
          for (var i = 0; i < companytaskWithAddedToShow.length; i++) {
            if (companytaskWithAddedToShow[i].TriggerType == 1) {
              data.push(companytaskWithAddedToShow[i]);
            }
          }
        }
        console.log(data);
        data.forEach(element => {
          var flag = true;
          if (this.agendaAddedTaskList) {
            for (var i = 0; i < this.agendaAddedTaskList.length; i++) {
              this.agendaAddedTaskList[i].IsNew = false;
              if (element.ID == this.agendaAddedTaskList[i].Task_id) {
                flag = false;
                break;
              }
            }
            if (flag) {
              // console.log('adding');
              unique.push(element);
            }
          } else {
            unique.push(element);
          }

        });



        this.companytasklist = unique;
        // console.log(unique);
        this.dtTriggerTaskAddingPopup.next();
      });
  }

  getCompanyTaskListInUpdateAgenda() {
    // console.log('----->>>>>', this.agendaAddedTaskList)
    this.companytasklist = [];
    var removeIndex = [];
    var companytaskWithAddedToShow = [];
    var companytaskWithoutAgendaTaskList = [];
    var data = [];
    this.taskService.getCompanyTaskList()
      .subscribe(taskList => {
        let checked = true;
        if (taskList.status == 0) {
          // var predefinedTaskList = $(taskList.tasksDatalist.TasksData).filter(function (i, n) { return n.TriggerType==1 });
          companytaskWithAddedToShow = taskList.tasksDatalist.TasksData;
          for (var i = 0; i < companytaskWithAddedToShow.length; i++) {
            if (companytaskWithAddedToShow[i].TriggerType == 1) {
              data.push(companytaskWithAddedToShow[i]);
            }
          }
          companytaskWithAddedToShow = data;
          for (var i = 0; i < companytaskWithAddedToShow.length; i++) {
            var flag = true;
            for (var j = 0; j < this.ActualDataToAgenda.length; j++) {
              if (companytaskWithAddedToShow[i].ID == this.ActualDataToAgenda[j].Task_id) {
                flag = false;
                break;
              } else {
              }
            }
            if (flag) {
              companytaskWithoutAgendaTaskList.push(companytaskWithAddedToShow[i]);
            }
          }
          companytaskWithAddedToShow = companytaskWithoutAgendaTaskList;
          this.companytasklist = companytaskWithAddedToShow
          this.dtTriggerTaskAddingPopup.next();
        }
      });
  }



  companyTaskListBySearchFilter(searchParameters) {

    this.companytasklist = [];
    var searchedData = [];
    var companytaskWithoutAgendaTaskList = [];
    var companytaskWithAddedToShow = [];
    var data = [];
    this.taskService.getCompanyTaskListBySearchFilters(searchParameters)
      .subscribe(taskList => {
        if (taskList.status == 0) {


          console.log(taskList);
          //remove alredy existing data
          if (this.agendaAddedTaskList) {
            //On Update show nont available Task from agenda in search filter  this.agendaAddedTaskList 
            companytaskWithAddedToShow = taskList.tasksDatalist.TasksData;
            for (var i = 0; i < companytaskWithAddedToShow.length; i++) {
              if (companytaskWithAddedToShow[i].TriggerType == 1) {
                data.push(companytaskWithAddedToShow[i]);
              }
            }

            searchedData = data;

            var k = 0;
            for (var i = 0; i < searchedData.length; i++) {
              var flag = true;
              for (var j = 0; j < this.agendaAddedTaskList.length; j++) {
                if (searchedData[i].ID == this.agendaAddedTaskList[j].Task_id) {
                  flag = false;
                  break;
                } else {
                }
              }
              if (flag) {
                companytaskWithoutAgendaTaskList.push(searchedData[i]);
              }
            }
            searchedData = companytaskWithoutAgendaTaskList;

            this.companytasklist = searchedData;
          } else {
            // console.log(taskList);
            companytaskWithAddedToShow = taskList.tasksDatalist.TasksData;
            for (var i = 0; i < companytaskWithAddedToShow.length; i++) {
              if (companytaskWithAddedToShow[i].TriggerType == 1) {
                data.push(companytaskWithAddedToShow[i]);
              }
            }
            this.companytasklist = data;
          }
          this.dtTriggerTaskAddingPopup.next();
        }
      })
  }

  addCompliancesTaskToAgendaForm() {
    this.disabledOnclick = false;

    var table1 = $('#addedtaskTable').DataTable({ destroy: true });
    table1.destroy();

    var table2 = $('#companytaskTable').DataTable({ destroy: true });
    table2.destroy();

    this.dataAdd = true
    var addedFullData = this.companytasklist.filter(opt => opt.SelectedTasks).map(opt => opt);
    var nonAdded = this.companytasklist;
    this.companytasklist = []
    var j = 0;
    for (var i = 0; i < nonAdded.length; i++) {
      if (nonAdded[i].SelectedTasks == true) {
        // console.log(nonAdded[i]);
      } else {
        this.companytasklist[j] = nonAdded[i];
        j++;
      }
    }
    this.dtTriggerTaskAddingPopup.next()
    // console.log('addedFullData',addedFullData);
    var storingDataToAgenda = [];
    var existingDataOfAgenda = this.ActualDataToAgenda
    var i = 0;

    addedFullData.forEach(element => {
      storingDataToAgenda[i] = {
        Task_id: element.ID,
        TaskID: element.TaskID,
        TaskName: element.TaskName,
        TaskDescription: element.TaskDescription,
        GroupID: element.GroupID,
        GroupName: element.GroupName,
        IsGlobal: element.IsGlobal,
        IsNew: true
      }
      i++;
    });
    // console.log(storingDataToAgenda);
    if (this.agendaAddedTaskList) {
      this.agendaAddedTaskList = this.agendaAddedTaskList.concat(storingDataToAgenda);
    }
    else if (existingDataOfAgenda) {
      this.agendaAddedTaskList = existingDataOfAgenda.concat(storingDataToAgenda);
    }
    else {
      this.agendaAddedTaskList = storingDataToAgenda;
    }



    this.dtTriggerForAddedTask.next();
    // console.log(this.agendaAddedTaskList);
    $("#AddCompliancesDialog").modal('toggle');




  }

  removeTaskFromAgendaList(deletingTask_id) {
    var table = $('#addedtaskTable').DataTable({ destroy: true });
    table.destroy();

    if (_.size(this.deletedTasks)) {
      this.deletedTasks.push(deletingTask_id);
    } else {
      this.deletedTasks = [];
      this.deletedTasks.push(deletingTask_id);
    }


    console.log(deletingTask_id);
    console.log(this.agendaAddedTaskList);
    for (var i = 0; i < this.agendaAddedTaskList.length; i++) {
      var cur = this.agendaAddedTaskList[i];
      if (cur.Task_id == deletingTask_id) {
        this.agendaAddedTaskList.splice(i, 1);
        break;
      }
    }
    this.dtTriggerForAddedTask.next()

    this.getCompanyTaskList()
    console.log(this.agendaAddedTaskList);
  }

  refreshTaskList() {
    if (this.currentURL.includes('edit')) {
      var table = $('#companytaskTable').DataTable({ destroy: true });
      table.destroy();
      this.getCompanyTaskListInUpdateAgenda();
    } else {
      var table = $('#companytaskTable').DataTable({ destroy: true });

      table.destroy();
      this.getCompanyTaskList();
    }
    $("#groupdropdown").val("null");

    this.groupID = null;
    this.selectedAll = false;
    this.SearchtaskEventbasedorPeriodicModel = '1';
    this.SearchtaskUserdefinedorPredefinedModel = null;
  }





  getSelectedGroupID(ev) {
    var id = ev.target.value;
    this.groupID = id;
  }




  showTasksBySearchData() {
    var searchParameters = {
      EventBasedorPeriodic: this.SearchtaskEventbasedorPeriodicModel,
      UserdefinedorPredefined: this.SearchtaskUserdefinedorPredefinedModel,
      GroupId: this.groupID
    };

    if (searchParameters.EventBasedorPeriodic != undefined || searchParameters.GroupId != undefined || searchParameters.UserdefinedorPredefined != undefined) {
      var table = $('#companytaskTable').DataTable({ destroy: true });
      table.destroy();
      this.companyTaskListBySearchFilter(searchParameters);
    }
    // console.log(searchParameters);
  }

  getGroupmasterList() {
    this.groupTypes = [];
    this.groupMasterService.getGroupList()
      .subscribe((groupList:any) => {
        if (groupList.status == 0) {
          //this.groupTypes = groupList.groupList;
          this.groupTypes = this.commonFunction.sortByKey(groupList.groupList, 'GroupName');
        }
      })
  }

  dataAdd: boolean = false;


  checkAllIfselectAll() {
    for (var i = 0; i < this.companytasklist.length; i++) {
      this.companytasklist[i].SelectedTasks = this.selectedAll;
      this.IsSelectedTasks = this.selectedAll;
    }
  }

  checkIfAllSelected() {
    this.selectedAll = this.companytasklist.every(function (item: any) {
      return item.SelectedTask == true;

    })
  }

  checkselected(ev) {
    if (ev.target.checked == true) {
      this.IsSelectedTasks = true;
    }
    else {
      this.IsSelectedTasks = false;
    }
  }


  CheckCategory(decision: any) {
    // console.log(decision);
    if (decision == 'Yes') {
      this.catBoolean = true;
      this.agendaAddForm.controls.IsMeetingAssigned.setValue('No');
      this.CheckAssignMeeting('No');
    } else {

      this.catBoolean = false;
    }
  }

  CheckAssignMeeting(decision: any) {
    if (decision == 'Yes') {
      this.meetingBoolean = true
      this.agendaAddForm.controls.IscategorySelected.setValue('No');
      this.CheckCategory('No');
    } else {
      this.meetingBoolean = false;
    }
  }

  upload(agendaTitle, meetingType) {
    var file = this.filesToUpload;
    // console.log('this.filesToUpload',file);
    this.makeFileRequest(environment.pssUIBaseUrl + "agenda/UploadFiles", [], file, agendaTitle, meetingType).then((result) => {
      console.log('-------8-8-8-8-8-8-8-8-', result);
    });
  }

  fileChangeEvent(fileInput: any) {
    this.filesToUpload = <Array<File>>fileInput.target.files;
    var checkfile = this.commonFunction.checkFileExtensionForMeetingAgendaDocuments(fileInput);
    if (checkfile) {
      this.filesToUpload = <Array<File>>fileInput.target.files;
      this.fileExtension = true;
    } else {
      this.fileExtension = false;
    }
  }

  fileChangeEventMinuteDocument(fileInputForMin: any) {
    this.filesToUploadMinuteDocument = <Array<File>>fileInputForMin.target.files;
  }

  uploadMinuteDcoument(agendaTitle, meetingType) {
    var file = this.filesToUploadMinuteDocument;
    console.log(file)
    this.makeFileRequestMinuteDoc(environment.pssUIBaseUrl + "agenda/UploadFiles", [], file, agendaTitle, meetingType).then((result) => {
      // console.log(result);
      console.log('--rrrrrrrrrrrrrrrrrrrr-----8-8-8-8-8-8-8-8-', result)
    });
  }
  makeFileRequestMinuteDoc(url: string, params: Array<string>, files: Array<File>, agendaTitle: string, meetingType: string) {
    return new Promise((resolve, reject) => {
      var formData: any = new FormData();
      var self = this;
      self.FileChangedNameMinDoc = [];
      console.log('testest---------------')
      var xhr = new XMLHttpRequest();
      for (var i = 0; i < files.length; i++) {
        var newDate = Date.now();
        self.FileNameOrignalDisplayMinDoc.push(files[i].name.replace(',', ''));
        formData.append("file", files[i], newDate + '-' + files[i].name.replace(',', ''));
        self.FileChangedNameMinDoc.push(files[i].name.replace(',', ''));

        var document = {
          "DocumentName": agendaTitle + " - Agenda Document - " + i,
          "DateOfDocument": new Date(),
          "CompletedDate": null,
          "MeetingTypeID": meetingType,
          "ParentDocumentTypeID": null,
          "ParentSubDocumentTypeID": null,
          "DirectorKmp": "None",
          "DirectorID": null,
          "KMPID": null,
          "Remarks": "",
          "Overwrite": false,
          "Filename": newDate + '-' + files[i].name.replace(',', ''),
          "OriginalFileName": files[i].name.replace(',', ''),
          // "FilePath": "D:\\Harrier\\PSSProject\\pss_api\\uploads\\Document_Type\\",
          "CreatedBy": null,
          "CreatedDate": new Date(),
          "LastUpdateFiles": new Date(),
          "ModifiedBy": null,
          "ModifiedDate": null,
          "CompanyID": JSON.parse(localStorage.getItem("companyDetails")).companyID
        }
        self.documentArrMinDoc.push(document);
        console.log('tetttttlllpppp', self.documentArrMinDoc)
      }
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            resolve(JSON.parse(xhr.response));
          } else {
            reject(xhr.response);
          }
        }
      }
      xhr.open("POST", url, true);
      var token = localStorage.getItem('token')
      xhr.setRequestHeader('x-access-token', token)
      xhr.send(formData);
    });
  }

  makeFileRequest(url: string, params: Array<string>, files: Array<File>, agendaTitle: string, meetingType: string) {
    return new Promise((resolve, reject) => {
      var formData: any = new FormData();
      var xhr = new XMLHttpRequest();
      for (var i = 0; i < files.length; i++) {
        var newDate = Date.now();
        this.FileNameOrignalDisplay.push(files[i].name.replace(',', ''));
        formData.append("file", files[i], newDate + '-' + files[i].name.replace(',', ''));
        this.FileChangedName.push(files[i].name.replace(',', ''));
        //this.agendaAddForm.controls.uploadFile.setValue(formData);
        this.FileOrignalName = files[i].name.replace(',', '');
        this.changedName = newDate + '-' + files[i].name.replace(',', '');

        var document = {
          "DocumentName": agendaTitle + " - Agenda Document - " + i,
          "DateOfDocument": new Date(),
          "CompletedDate": null,
          "MeetingTypeID": meetingType,
          "ParentDocumentTypeID": null,
          "ParentSubDocumentTypeID": null,
          "DirectorKmp": "None",
          "DirectorID": null,
          "KMPID": null,
          "Remarks": "",
          "Overwrite": false,
          "Filename": newDate + '-' + files[i].name.replace(',', ''),
          "OriginalFileName": files[i].name.replace(',', ''),
          // "FilePath": "D:\\Harrier\\PSSProject\\pss_api\\uploads\\Document_Type\\",
          "CreatedBy": null,
          "CreatedDate": new Date(),
          "LastUpdateFiles": new Date(),
          "ModifiedBy": null,
          "ModifiedDate": null,
          "CompanyID": JSON.parse(localStorage.getItem("companyDetails")).companyID
        }
        this.documentArr.push(document);
      }
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            resolve(JSON.parse(xhr.response));
          } else {
            reject(xhr.response);
          }
        }
      }
      xhr.open("POST", url, true);
      var token = localStorage.getItem('token')
      xhr.setRequestHeader('x-access-token', token)
      xhr.send(formData);
    });
  }


  getMeetingTypeList() {
    this.meetingTypes = [];
    this.processMasterService.getMeetingTypeList()
      .subscribe(meetingTypeList => {
        if (meetingTypeList.status == 0) {
          // console.log('meetingTypeList', meetingTypeList.meetingTypeList);
          this.meetingTypes = this.commonFunction.sortByKey(meetingTypeList.meetingTypeList, 'MeetingType');
        }
      })
    // this.meetingType = [
    //   { id: '1', name: 'Board' },
    //   { id: '2', name: 'Independent Directors' },
    //   { id: '3', name: 'Annual General Meeting' },
    //   { id: '4', name: 'Extraordinary General Meeting' },
    //   { id: '5', name: 'Postal Ballot' },
    //   { id: '5', name: 'Others' },
    // ];
  }

  getCategoryList() {
    this.categories = [];
    this.categoryMasterService.getCategoryList()
      .subscribe(categoryList => {
        if (categoryList.status == 0) {
          this.categories = this.commonFunction.sortByKey(categoryList.categoryList, 'CategoryName');
        }
      });
  }


  // getCategoryList(meetingTypeID) {

  //   this.categories = [];
  //   this.categoryMasterService.getCategoryListByMeetingTypeID(meetingTypeID)
  //     .subscribe(categoryList => {
  //       if (categoryList.status == 0) {
  //         this.categories =  this.commonFunction.sortByKey(categoryList.categoryList, 'CategoryName');;
  //         console.log(this.categories);
  //       }
  //     });
  // }

  getpredefinedTaskList() {
    this.preDefinedTask = [];
    this.agendaService.getpredefinedTask().subscribe(tasklist => {
      if (tasklist.status == 0) {
        this.preDefinedTasknew = tasklist.taskList;
        // console.log('( this.preDefinedTaskNew)', this.preDefinedTasknew);
        // console.log('( this.preDefinedTask)', this.preDefinedTask);
        var removingKeyArr = [];
        if (this.preDefinedTask.length > 0) {
          var newtsk = [];
          newtsk = this.preDefinedTasknew;
          for (var key in this.preDefinedTasknew) {
            for (var key2 in this.preDefinedTask) {
              if (this.preDefinedTasknew[key].TaskName == this.preDefinedTask[key2].TaskName) {
                removingKeyArr = removingKeyArr.concat(key);
                newtsk.splice(parseInt(key), 1);
              }
            }//second For Loop
          }//first for loop
          this.preDefinedTasknew = newtsk;
        }//if-->checking available task for edit to remove duplicates
      }//if-->checking status of api
    })
  }

  getSelectedTaskList(taskList) {
    var Arr = [];
    var newArr = [];
    Arr = taskList.split(',');
    //  console.log('taskList','--->'+taskList+'<----');
    if (taskList != "") {
      for (var i = 0; i < Arr.length; i++) {
        var element = Arr[i];
        newArr = newArr.concat({ TaskName: element });
      }
      this.preDefinedTask = newArr;
    }
  }

  revert() {
    this.imageAdd = false;
    this.imageAddRev = false;
    this.imageEdit = true;
  }

  revertDocMin() {
    this.minuteDocAdd = false;
    this.minuteDocAddRev = false;
    this.minuteDocEdit = true;
  }

  removeDoc() {
    this.imageAdd = true;
    this.imageAddRev = true;
    this.imageEdit = false;
    this.AddNewAgendafiles = false;
    this.agendaFiles = [];
  }


  addNewDoc() {
    this.imageAdd = true;
    this.imageEdit = false;
    this.imageAddRev = true;
    // this.AddNewAgendafiles = true;
    this.AddNewAgendafiles = false;
  }

  addNewMinDoc() {
    this.minuteDocAdd = true;
    this.minuteDocEdit = false;
    this.minuteDocAddRev = true;
  }

  // fromLocalStorage : any;
  back() {
    var fromMeeting = localStorage.getItem('fromMeeting');
    localStorage.removeItem('fromMeeting');
    if (fromMeeting != undefined || fromMeeting != null) {
      this.router.navigate(
      [{ outlets: { 'structure-outlet': ['addMeetings', 'edit',  fromMeeting , 'Agenda'] } }],
      { relativeTo: this.route.parent });
      // this.router.navigate(['/meeting/edit/' + fromMeeting + '/Agenda']);
    } else {
      this.router.navigate(
      [{ outlets: { 'structure-outlet': ['agenda'] } }],
      { relativeTo: this.route.parent });
      // this.router.navigate(['/agenda']);
    }
  }

  isChangeToMeeting: any;
  assignedMeetingID: any;
  getFormDetaisOnEdit() {
    // console.log(this.currentURL);
    var fromMeeting = localStorage.getItem('fromMeeting');
    // localStorage.removeItem('fromMeeting');
    this.assignedMeetingID = fromMeeting;
    this.activatedRoute.params.subscribe(params => {
      if (params['agendaId'] != undefined) {
        // it is edit page
        this.agendaId = params['agendaId'];
        this.agendaService.getAgendaDetaisFromMeetingByID(fromMeeting, this.agendaId).subscribe(agendaDetails => {
          console.log(agendaDetails)
          if (agendaDetails.status == 0) {
            // ===== Replace Library Agenda Doc START =======
            let uniqueUserId = JSON.parse(localStorage.getItem('user')).UniqueUserId;
            let uniqueCompanyId = JSON.parse(localStorage.getItem('user')).CompanyId;
            this.userMasterService.getAssociatedCompanyList(uniqueUserId).subscribe((response:any) => {
             
              if (response.status == 200) {
                var result = JSON.parse(response._body);
                result.companyList.forEach(compData => {
                  if (compData._id != uniqueCompanyId) {
                    this.companyNameData.push({
                      id: compData._id,
                      name: compData.CompanyName
                    })
                  }
                });
              }
            });

            if (this.agendaId != null && this.agendaId != undefined && this.agendaId != "") {
              this.meetingService.getAgendaByID(this.agendaId)
                .subscribe(agendaData => {
                  // console.log('agendaData : ', agendaData.agendaDetails[0].PSSMasterAgendaID);
                  if (agendaData.status == 0) {
                    if (agendaData.agendaDetails[0].PSSMasterAgendaID != null && agendaData.agendaDetails[0].PSSMasterAgendaID != undefined && agendaData.agendaDetails[0].PSSMasterAgendaID != "") {
                      this.isPSSMasterAgenda = true;
                    } else {
                      this.isPSSMasterAgenda = false;
                    }
                  }
                });
            }

            var catID = agendaDetails.agendaDetails[0].CategoryID;
            console.log('agendaDetails ID  ==== > ', catID);
            if (catID != null && catID != undefined && catID != "") {
              this.categoryMasterService.getCategoryById(catID)
                .subscribe(category => {
                  if (category.status == 0) {
                    this.isCategoryGlobal = category.categoryList[0].IsGlobal;
                    this.categoryIdForEdit = category.categoryList[0]._id;
                    this.categoryNameForEdit = category.categoryList[0].CategoryName;
                  }
                });
            }
            // ===== Replace Library Agenda Doc END =======

            this.addedProcess = agendaDetails.agendaDetails[0].Processes;
            this.addedProcess.forEach(element => {
              element.IsNew = false;
            })
            // console.log('------->>>>>>', this.processes);
            // console.log('agendaDetails', agendaDetails.agendaDetails[0].IsMeetingAssigned);
            // console.log('agendaDetails', agendaDetails.agendaDetails[0].meetingID);
            //debugger
            if (agendaDetails.agendaDetails[0].IsMeetingAssigned === 'Yes') {
              this.getMeetingFromType(agendaDetails.agendaDetails[0].MeetingTypeID)
              this.agendaAddForm.controls.meetingType.disable();
              this.agendaAddForm.controls.IscategorySelected.disable();
              this.agendaAddForm.controls.IsMeetingAssigned.disable();
              this.agendaAddForm.controls.meeting.disable();
              this.isChangeToMeeting = "Yes"
            } else {
              this.agendaAddForm.controls.meetingType.disable();
              this.agendaAddForm.controls.IscategorySelected.disable();
              this.agendaAddForm.controls.IsMeetingAssigned.disable();
              this.agendaAddForm.controls.meeting.disable();
              this.agendaAddForm.controls.selectCategory.disable();
              this.isChangeToMeeting = "No"
            }
            // this.agendaAddForm.controls.meeting.setValue(agendaDetails.agendaDetails[0].meetingID);
            this.isLibraryAgenda = agendaDetails.agendaDetails[0].IscategorySelected;

            var agendaNumber = agendaDetails.agendaDetails[0].AgendaNumber;
            var IscategorySelected = agendaDetails.agendaDetails[0].IscategorySelected;//added Field
            var IsMeetingAssigned = agendaDetails.agendaDetails[0].IsMeetingAssigned;//added Field
            var meetingType = agendaDetails.agendaDetails[0].MeetingTypeID;
            this.meetingTypeID = agendaDetails.agendaDetails[0].MeetingTypeID;
            var selectCategory = agendaDetails.agendaDetails[0].CategoryID;//Modified added field
            var meeting = agendaDetails.agendaDetails[0].meetingID;// added field
            var agendaTitle = agendaDetails.agendaDetails[0].AgendaTitle;
            this.PageTitle = agendaTitle;
            var agendaCompliance = agendaDetails.agendaDetails[0].Compliance;
            var image = agendaDetails.agendaDetails[0].PreambleAndResolution_FileName;
            this.PreambleAndResolution_DocId = agendaDetails.agendaDetails[0].PreambleAndResolution_DocId;
            var libaryType = agendaDetails.agendaDetails[0].libaryType;
            var agendaType = agendaDetails.agendaDetails[0].agendaTypeSelection;
            var department = agendaDetails.agendaDetails[0].departmentID;
            this.agendaFiles = agendaDetails.agendaDetails[0].AgendaFiles;
            this.CheckCategory(IscategorySelected)
            this.CheckAssignMeeting(IsMeetingAssigned)
            var table = $('#addedtaskTable').DataTable({ destroy: true });
            table.destroy();

            var table1 = $('#processTable').DataTable({ destroy: true });
            table1.destroy();

            var table2 = $('#processTablePopup').DataTable({ destroy: true });
            table2.destroy();

            this.processes = [];

            //-------------------------------------------------------------------------------------------------------------------

            // for (var j = 0; j < this.addedProcess.length; j++) {
            //   var index = this.indexOfElementArray(this.processes, this.addedProcess[j]);
            //   console.log(index);
            //   this.processes.splice(index, 1);
            // }

            this.dtTriggerProcessAddingPopup.next();
            this.dtTriggerForAddedProcess.next();

            var existingDataOfAgenda = agendaDetails.agendaDetails[0].Compliance;
            agendaDetails.agendaDetails[0].Compliance;

            existingDataOfAgenda.forEach(element => {
              element.IsNew = false;
            });

            this.agendaAddedTaskList = existingDataOfAgenda;

            this.dtTriggerForAddedTask.next();
            this.ActualDataToAgenda = agendaDetails.agendaDetails[0].Compliance;
            this.agendaAddForm.controls.agendaNumber.setValue(agendaDetails.agendaDetails[0].AgendaNumber);
            this.agendaAddForm.controls.meetingType.setValue(agendaDetails.agendaDetails[0].MeetingTypeID);
            // this.agendaAddForm.controls.selectCategory.setValue(agendaDetails.agendaDetails[0].CategoryID);
            this.agendaAddForm.controls.agendaTitle.setValue(agendaDetails.agendaDetails[0].AgendaTitle);
            this.agendaAddForm.controls.agendaCompliance.setValue(agendaDetails.agendaDetails[0].Compliance);
            this.agendaAddForm.controls.IscategorySelected.setValue(agendaDetails.agendaDetails[0].IscategorySelected);
            this.agendaAddForm.controls.IsMeetingAssigned.setValue(agendaDetails.agendaDetails[0].IsMeetingAssigned);
            this.agendaAddForm.controls.meeting.setValue(agendaDetails.agendaDetails[0].meetingID);
            this.agendaAddForm.controls.selectCategory.setValue(agendaDetails.agendaDetails[0].CategoryID);
            this.agendaAddForm.controls.agendaNumberPrefix.setValue(agendaDetails.agendaDetails[0].agendaNumberPrefix);
            this.agendaAddForm.controls.department.setValue(department);
            this.agendaAddForm.controls.agendaType.setValue(agendaType);
            $('#MeetingTypeName').val(agendaDetails.MeetingType);
            // this.getSelectedTaskList(agendaDetails.agendaDetails[0].Compliance)
            if (IscategorySelected == undefined || IscategorySelected == null || IscategorySelected == "null") { this.agendaAddForm.controls.selectCategory.setValue(null); }
            if (IsMeetingAssigned == undefined || IsMeetingAssigned == null || IsMeetingAssigned == "null") {
              this.agendaAddForm.controls.meeting.setValue(null);
            }
            this.agendaAddForm.controls.indexGrouping_id.setValue(agendaDetails.agendaDetails[0].indexGrouping_id);
            this.groupName = agendaDetails.agendaDetails[0].groupName;
            this.groupNumber = agendaDetails.agendaDetails[0].groupNumber;
            console.log(this.agendaAddForm.controls)
            if (agendaDetails.agendaDetails[0].AgendaMinuteDocument) {
              this.agendaAddForm.controls.imageMinDoc.setValue(agendaDetails.agendaDetails[0].AgendaMinuteDocument.DocName);
              if (agendaDetails.agendaDetails[0].AgendaMinuteDocument.DocName == 'File Not Available' || agendaDetails.agendaDetails[0].AgendaMinuteDocument.DocName == "" || agendaDetails.agendaDetails[0].AgendaMinuteDocument.DocName == undefined || agendaDetails.agendaDetails[0].AgendaMinuteDocument.DocName == null) {
                this.minuteDocAdd = true;
                this.minuteDocAddRev = false;
                this.minuteDocEdit = false;
              }
            }
            console.log('*********************', agendaDetails.agendaDetails[0].indexGrouping_id)
            // console.log('file details------>',agendaDetails.agendaDetails[0].PreambleAndResolution_FileName);
            this.agendaAddForm.controls.image.setValue(agendaDetails.agendaDetails[0].PreambleAndResolution_FileName);
            if (agendaDetails.agendaDetails[0].PreambleAndResolution_FileName == "" || agendaDetails.agendaDetails[0].PreambleAndResolution_FileName == undefined || agendaDetails.agendaDetails[0].PreambleAndResolution_FileName == 'File Not Available') {
              this.imageAdd = true;
              this.imageAddRev = false;
              // this.imageAddRev=true;
              this.imageEdit = false;
            }

            this.filenamedit = agendaDetails.agendaDetails[0].PreambleAndResolution_FileName;
            this.filenameoriginal = agendaDetails.agendaDetails[0].orinalFile;

            this.previousAgendafilename = agendaDetails.agendaDetails[0].PreambleAndResolution_FileName;
            this.previousAgendafileoriginal = agendaDetails.agendaDetails[0].orinalFile;


            this.TotalFile = new Array();
            this.TotalFileMinDoc = new Array();
            this.documentsDownload = new Array();
            this.actualFileName = new Array();
            this.documentsDownload = agendaDetails.agendaDetails[0].PreambleAndResolution_FileName.split(',');
            if (agendaDetails.agendaDetails[0].orinalFile) {
              this.actualFileName = agendaDetails.agendaDetails[0].orinalFile.split(',');
            }
            //console.log('this.documentsDownload', this.documentsDownload);

            this.documentsDownloadMinute = new Array();
            if (agendaDetails.agendaDetails[0].AgendaMinuteDocument && agendaDetails.agendaDetails[0].AgendaMinuteDocument.DocName) {
              this.documentsDownloadMinute = agendaDetails.agendaDetails[0].AgendaMinuteDocument.DocName.split(',');
              this.FileChangedNameMinDoc.push(agendaDetails.agendaDetails[0].AgendaMinuteDocument.DocName);
              this.FileUnchangedNameMinDoc.push(agendaDetails.agendaDetails[0].AgendaMinuteDocument.DocName);
              this.minutesDocId = agendaDetails.agendaDetails[0].AgendaMinuteDocument.DocumentManagementID;
            }
            for (var i = 0; i < this.documentsDownloadMinute.length; i++) {
              this.documentsDownloadMinute[i] = this.documentsDownloadMinute[i];
              this.TotalFileMinDoc[i] = { srno: i, FileChangedName: this.documentsDownloadMinute[i], actualFileName: this.actualFileName[i] };
            }

            for (var i = 0; i < this.documentsDownload.length; i++) {
              this.documentsDownload[i] = this.documentsDownload[i];
              this.TotalFile[i] = { srno: i, FileChangedName: this.documentsDownload[i], actualFileName: this.actualFileName[i] };
            }
            console.log('==========================', this.TotalFile);

          }

        })
        this.dtTriggerForAddedTask.next()
      }
    })






  }

  booleanMeetingValidate: boolean;
  booleanCategoryValidate: boolean;

  addAgenda() {

    // debugger;
    this.disabledOnclick = true;
    this.agendaFiles = [];
    var agendaNumber = this.agendaAddForm.controls.agendaNumber.value;
    var IscategorySelected = this.agendaAddForm.controls.IscategorySelected.value;//added Field
    var IsMeetingAssigned = this.agendaAddForm.controls.IsMeetingAssigned.value;//added Field
    var meetingType = this.agendaAddForm.controls.meetingType.value;
    var selectCategory = this.agendaAddForm.controls.selectCategory.value;//Modified added field
    var meeting = this.agendaAddForm.controls.meeting.value;// added field
    var agendaTitle = this.agendaAddForm.controls.agendaTitle.value;
    // var agendaCompliance = this.agendaAddForm.controls.agendaCompliance.value;
    var agendaCompliance = this.agendaAddedTaskList;
    var image = this.agendaAddForm.controls.image.value;
    var agendaType = this.agendaAddForm.controls.agendaType.value;
    var department = this.agendaAddForm.controls.department.value;
    var libaryType;
    var agendaType;

    if (IscategorySelected == 'No') {
      libaryType = 'Non-Library';
      this.agendaAddForm.controls.selectCategory.setValue("null"); selectCategory = null;
    }
    if (IsMeetingAssigned == 'No') {
      agendaType = 'Open';
      this.agendaAddForm.controls.meeting.setValue("null"); meeting = null;
    }
    if (IscategorySelected == 'Yes') { libaryType = 'Library'; }
    if (IsMeetingAssigned == 'Yes') { agendaType = 'Non-Open'; }

    if ((IsMeetingAssigned == 'Yes' && (meeting == null || meeting == "null")) || (IscategorySelected == 'Yes' && (selectCategory == null || selectCategory == "null"))) {

      if (IscategorySelected == 'Yes' && (selectCategory == null || selectCategory == "null")) {
        this.booleanCategoryValidate = true;

      } else {
        this.booleanCategoryValidate = false;
      }
      if ((IsMeetingAssigned == 'Yes' && (meeting == null || meeting == "null"))) {
        this.booleanMeetingValidate = true;

      } else {
        this.booleanMeetingValidate = false;
      }

      return false;
    }
    var indexGrouping_id = this.agendaAddForm.controls.indexGrouping_id.value;


    this.isClickedOnce = true;
    var inputMime = this.filesToUpload[0].type;
    if (inputMime == "docx") {
      this.upload(this.agendaAddForm.controls.agendaTitle.value, this.agendaAddForm.controls.meetingType.value);
    } else {
      this.alert.error('Please upload pdf file from list screen');
    }

    this.uploadMinuteDcoument(agendaTitle, this.agendaAddForm.controls.meetingType.value);

    if (this.documentArr.length > 0 && this.documentArrMinDoc.length > 0) {
      this.agendaService.updateAgendaDocumentInDB(this.documentArr).subscribe(documentData => {
        for (var index = 0; index < documentData.Data.length; index++) {
          var obj = { 'FileName': documentData.Data[index].Filename, 'DocumentManagementID': documentData.Data[index]._id }
          this.agendaFiles.push(obj);
        }

        this.agendaService.updateAgendaDocumentInDB(this.documentArrMinDoc).subscribe(documentDataMinDoc => {
          for (var index = 0; index < documentDataMinDoc.Data.length; index++) {
            var obj = { 'FileName': documentDataMinDoc.Data[index].Filename, 'DocumentManagementID': documentDataMinDoc.Data[index]._id }
            this.MinDocFiles.push(obj);
          }

          console.log(this.agendaFiles)
          var varagendaCompliance = $('.select2').val();
          this.agendaAddForm.controls.agendaCompliance.setValue(varagendaCompliance);
          this.agendaAddForm.controls.image.setValue(this.changedName);
          var newAgenda = {
            agendaNumber: this.agendaAddForm.controls.agendaNumber.value,
            meetingType: this.agendaAddForm.controls.meetingType.value,
            selectCategory: this.agendaAddForm.controls.selectCategory.value,
            agendaTitle: this.agendaAddForm.controls.agendaTitle.value,
            agendaCompliance: this.agendaAddedTaskList,
            processes: this.addedProcess,
            IscategorySelected: IscategorySelected,
            IsMeetingAssigned: IsMeetingAssigned,

            meetingID: meeting,
            libaryType: libaryType,
            agendaTypeSelection: this.agendaAddForm.controls.agendaType.value,
            department: this.agendaAddForm.controls.department.value,
            agendaType: agendaType,
            orinalFile: this.FileNameOrignalDisplay,
            Upload: this.FileChangedName,
            image: this.agendaAddForm.controls.image.value,
            CreatedBy: '',
            CreatedDate: new Date(),
            ModifiedBy: '',
            ModifiedDate: '',
            AgendaFiles: this.agendaFiles,
            MinDocFiles: this.MinDocFiles,
            agendaNumberPrefix: this.agendaAddForm.controls.agendaNumberPrefix.value,
            PreambleAndResolution_DocId: documentData.Data[0]._id,
            MinuteDocument_DocId: documentDataMinDoc.Data[0]._id,
            MinuteDocument_fileName: this.FileChangedNameMinDoc,
            indexGrouping_id: indexGrouping_id,
          }
          console.log('newAgenda------------', newAgenda);
          this.loading = true;
          this.agendaService.addAgenda(newAgenda).subscribe(agenda => {
            if (agenda.status == 0) {
              this.loading = false;
              if (this.FromMeetingmeetingID != undefined || this.FromMeetingmeetingID != null) {
                 this.alert.successWithOk1(agenda.message, ()=>{this.router.navigate(
                  [{ outlets: { 'structure-outlet': ['addMeetings', 'edit', this.FromMeetingmeetingID, 'Agenda'] } }],
                  { relativeTo: this.route.parent });});
                // this.alert.successWithOk(agenda.message, '/meeting/edit/' + this.FromMeetingmeetingID + '/Agenda');
              } else {
                this.alert.successWithOk1(agenda.message, ()=>{this.router.navigate(
                [{ outlets: { 'structure-outlet': ['agenda'] } }],
                { relativeTo: this.route.parent });});
                // this.alert.successWithOk(agenda.message, '/agenda')
              }
            } else if (agenda.status == 55) {
              this.loading = false;
              this.meetingService.downloadSplitFailureFile(agenda.filename);
              if (this.FromMeetingmeetingID != undefined || this.FromMeetingmeetingID != null) {
                  this.alert.successWithOk1(agenda.message, ()=>{this.router.navigate(
                  [{ outlets: { 'structure-outlet': ['addMeetings', 'edit', this.FromMeetingmeetingID, 'Agenda'] } }],
                  { relativeTo: this.route.parent });});
                // this.alert.successWithOk(agenda.message, '/meeting/edit/' + this.FromMeetingmeetingID + '/Agenda');
              } else {
                 this.alert.successWithOk1(agenda.message, ()=>{this.router.navigate(
                [{ outlets: { 'structure-outlet': ['agenda'] } }],
                { relativeTo: this.route.parent });});
                // this.alert.successWithOk(agenda.message, '/agenda')
              }
            }
            else {
              this.loading = false;
              this.alert.error(agenda.message);
            }
          });
        })
      });
    } else if (this.documentArr.length > 0) {
      this.agendaService.updateAgendaDocumentInDB(this.documentArr).subscribe(documentData => {
        this.disabledOnclick = false;
        console.log(documentData);
        console.log(documentData.Data.Filename);
        console.log(documentData.Data._id);
        for (var index = 0; index < documentData.Data.length; index++) {
          var obj = { 'FileName': documentData.Data[index].Filename, 'DocumentManagementID': documentData.Data[index]._id }
          this.agendaFiles.push(obj);
        }
        var varagendaCompliance = $('.select2').val();
        this.agendaAddForm.controls.agendaCompliance.setValue(varagendaCompliance);
        this.agendaAddForm.controls.image.setValue(this.changedName);
        var newAgenda = {
          agendaNumber: this.agendaAddForm.controls.agendaNumber.value,
          meetingType: this.agendaAddForm.controls.meetingType.value,
          selectCategory: this.agendaAddForm.controls.selectCategory.value,
          agendaTitle: this.agendaAddForm.controls.agendaTitle.value,
          agendaCompliance: this.agendaAddedTaskList,
          processes: this.addedProcess,
          IscategorySelected: IscategorySelected,
          IsMeetingAssigned: IsMeetingAssigned,
          meetingID: meeting,
          libaryType: libaryType,
          agendaTypeSelection: this.agendaAddForm.controls.agendaType.value,
          department: this.agendaAddForm.controls.department.value,
          agendaType: agendaType,
          Upload: this.FileChangedName,
          orinalFile: this.FileOrignalName,
          image: this.agendaAddForm.controls.image.value,
          CreatedBy: '',
          CreatedDate: new Date(),
          ModifiedBy: '',
          ModifiedDate: '',
          agendaFiles: this.agendaFiles,
          agendaNumberPrefix: this.agendaAddForm.controls.agendaNumberPrefix.value,
          PreambleAndResolution_DocId: documentData.Data[0]._id,
          indexGrouping_id: indexGrouping_id,
          MinuteDocument_fileName: this.FileChangedNameMinDoc,
        }
        // console.log('newAgenda------------', newAgenda);
        this.loading = true;
        this.agendaService.addAgenda(newAgenda).subscribe(agenda => {
          // console.log(agenda);
          if (agenda.status == 0) {
            this.loading = false;
            if (this.FromMeetingmeetingID != undefined || this.FromMeetingmeetingID != null) {
               this.alert.successWithOk1(agenda.message, ()=>{this.router.navigate(
                [{ outlets: { 'structure-outlet': ['addMeetings', 'edit', this.FromMeetingmeetingID] } }],
                { relativeTo: this.route.parent });});
              // this.alert.successWithOk(agenda.message, '/meeting/edit/' + this.FromMeetingmeetingID);
            } else {
                this.alert.successWithOk1(agenda.message, ()=>{this.router.navigate(
                [{ outlets: { 'structure-outlet': ['agenda'] } }],
                { relativeTo: this.route.parent });});
              // this.alert.successWithOk(agenda.message, '/agenda')
            }
          }
          else if (agenda.status == 55) {
            this.loading = false;
            this.meetingService.downloadSplitFailureFile(agenda.filename);
            if (this.FromMeetingmeetingID != undefined || this.FromMeetingmeetingID != null) {
               this.alert.successWithOk1(agenda.message, ()=>{this.router.navigate(
                [{ outlets: { 'structure-outlet': ['addMeetings', 'edit', this.FromMeetingmeetingID,'Agenda'] } }],
                { relativeTo: this.route.parent });});
              // this.alert.successWithOk(agenda.message, '/meeting/edit/' + this.FromMeetingmeetingID + '/Agenda');
            } else {
               this.alert.successWithOk1(agenda.message, ()=>{this.router.navigate(
                [{ outlets: { 'structure-outlet': ['agenda'] } }],
                { relativeTo: this.route.parent });});
              // this.alert.successWithOk(agenda.message, '/agenda')
            }
          }
          else {
            this.loading = false;
            this.alert.error(agenda.message);
          }
        });
      })
    } else if (this.documentArrMinDoc.length > 0) {

      this.agendaService.updateAgendaDocumentInDB(this.documentArrMinDoc).subscribe(documentDataMinDoc => {
        for (var index = 0; index < documentDataMinDoc.Data.length; index++) {
          var obj = { 'FileName': documentDataMinDoc.Data[index].Filename, 'DocumentManagementID': documentDataMinDoc.Data[index]._id }
          this.MinDocFiles.push(obj);
        }

        console.log(this.agendaFiles)
        var varagendaCompliance = $('.select2').val();
        this.agendaAddForm.controls.agendaCompliance.setValue(varagendaCompliance);
        this.agendaAddForm.controls.image.setValue(this.changedName);
        var newAgenda = {
          agendaNumber: this.agendaAddForm.controls.agendaNumber.value,
          meetingType: this.agendaAddForm.controls.meetingType.value,
          selectCategory: this.agendaAddForm.controls.selectCategory.value,
          agendaTitle: this.agendaAddForm.controls.agendaTitle.value,
          agendaCompliance: this.agendaAddedTaskList,
          processes: this.addedProcess,
          IscategorySelected: IscategorySelected,
          IsMeetingAssigned: IsMeetingAssigned,
          meetingID: meeting,
          libaryType: libaryType,
          agendaTypeSelection: this.agendaAddForm.controls.agendaType.value,
          department: this.agendaAddForm.controls.department.value,
          agendaType: agendaType,
          orinalFile: this.FileNameOrignalDisplay,
          Upload: this.FileChangedName,
          image: this.agendaAddForm.controls.image.value,
          CreatedBy: '',
          CreatedDate: new Date(),
          ModifiedBy: '',
          ModifiedDate: '',
          AgendaFiles: this.agendaFiles,
          MinDocFiles: this.MinDocFiles,
          agendaNumberPrefix: this.agendaAddForm.controls.agendaNumberPrefix.value,
          MinuteDocument_DocId: documentDataMinDoc.Data[0]._id,
          MinuteDocument_fileName: this.FileChangedNameMinDoc,
          indexGrouping_id: indexGrouping_id
        }
        console.log('newAgenda------------', newAgenda);
        this.loading = true;
        this.agendaService.addAgenda(newAgenda).subscribe(agenda => {
          if (agenda.status == 0) {
            this.loading = false;
            if (this.FromMeetingmeetingID != undefined || this.FromMeetingmeetingID != null) {
               this.alert.successWithOk1(agenda.message, ()=>{this.router.navigate(
                [{ outlets: { 'structure-outlet': ['addMeetings', 'edit', this.FromMeetingmeetingID,'Agenda'] } }],
                { relativeTo: this.route.parent });});
              // this.alert.successWithOk(agenda.message, '/meeting/edit/' + this.FromMeetingmeetingID + '/Agenda');
            } else {
               this.alert.successWithOk1(agenda.message, ()=>{this.router.navigate(
                [{ outlets: { 'structure-outlet': ['agenda'] } }],
                { relativeTo: this.route.parent });});
              // this.alert.successWithOk(agenda.message, '/agenda')
            }
          } else if (agenda.status == 55) {
            this.loading = false;
            this.meetingService.downloadSplitFailureFile(agenda.filename);
            if (this.FromMeetingmeetingID != undefined || this.FromMeetingmeetingID != null) {
               this.alert.successWithOk1(agenda.message, ()=>{this.router.navigate(
                [{ outlets: { 'structure-outlet': ['addMeetings', 'edit', this.FromMeetingmeetingID,'Agenda'] } }],
                { relativeTo: this.route.parent });});
              //  this.alert.successWithOk1(agenda.message, ()=>{this.router.navigate(
              //   [{ outlets: { 'structure-outlet': ['meeting', 'edit', this.FromMeetingmeetingID,'/Agenda'] } }],
              //   { relativeTo: this.route.parent });});
              // this.alert.successWithOk(agenda.message, '/meeting/edit/' + this.FromMeetingmeetingID + '/Agenda');
            } else {
               this.alert.successWithOk1(agenda.message, ()=>{this.router.navigate(
                [{ outlets: { 'structure-outlet': ['agenda'] } }],
                { relativeTo: this.route.parent });});
              // this.alert.successWithOk(agenda.message, '/agenda')
            }
          }
          else {
            this.loading = false;
            this.alert.error(agenda.message);
          }
        });
      });


    } else {
      var varagendaCompliance = $('.select2').val();
      this.agendaAddForm.controls.agendaCompliance.setValue(varagendaCompliance);
      this.agendaAddForm.controls.image.setValue(this.changedName);
      var newAgenda = {
        agendaNumber: this.agendaAddForm.controls.agendaNumber.value,
        meetingType: this.agendaAddForm.controls.meetingType.value,
        selectCategory: this.agendaAddForm.controls.selectCategory.value,
        agendaTitle: this.agendaAddForm.controls.agendaTitle.value,
        agendaCompliance: this.agendaAddedTaskList,
        processes: this.addedProcess,
        IscategorySelected: IscategorySelected,
        IsMeetingAssigned: IsMeetingAssigned,
        meetingID: meeting,
        libaryType: libaryType,
        agendaTypeSelection: this.agendaAddForm.controls.agendaType.value,
        department: this.agendaAddForm.controls.department.value,
        agendaType: agendaType,
        Upload: this.FileChangedName,
        orinalFile: this.FileOrignalName,
        image: this.agendaAddForm.controls.image.value,
        CreatedBy: '',
        CreatedDate: new Date(),
        ModifiedBy: '',
        ModifiedDate: '',
        agendaFiles: this.agendaFiles,
        agendaNumberPrefix: this.agendaAddForm.controls.agendaNumberPrefix.value,
        indexGrouping_id: indexGrouping_id,
        MinuteDocument_fileName: this.FileChangedNameMinDoc,
      }
      // console.log('newAgenda------------', newAgenda);
      this.loading = true;
      this.agendaService.addAgenda(newAgenda).subscribe(agenda => {
        // console.log(agenda);
        this.disabledOnclick = false;
        if (agenda.status == 0) {
          this.loading = false;
          if (this.FromMeetingmeetingID != undefined || this.FromMeetingmeetingID != null) {
             this.alert.successWithOk1(agenda.message, ()=>{this.router.navigate(
                [{ outlets: { 'structure-outlet': ['addMeetings', 'edit', this.FromMeetingmeetingID] } }],
                { relativeTo: this.route.parent });});
            // this.alert.successWithOk(agenda.message, '/meeting/edit/' + this.FromMeetingmeetingID);
          } else {
             this.alert.successWithOk1(agenda.message, ()=>{this.router.navigate(
                [{ outlets: { 'structure-outlet': ['agenda'] } }],
                { relativeTo: this.route.parent });});
            // this.alert.successWithOk(agenda.message, '/agenda')
          }
        }
        else {
          this.loading = false;
          this.alert.error(agenda.message);
        }
      });
    }


  }


  // updateAgenda(event) {
  //   console.log(this.filesToUpload)
  //   var inputMime = "";
  //   if(this.filesToUpload && this.filesToUpload.length > 0) {
  //     inputMime = this.filesToUpload[0].type;
  //   }


  //   this.disabledOnclick = true;
  //   var varagendaCompliance = $('.select2').val();
  //   // alert(varagendaCompliance);
  //   //console.log('file name--->',this.agendaAddForm.controls.image.value);
  //   // ===== Replace Library Agenda Doc START =======
  //   var updateLibraryAgendaDoc = false;
  //   var companyIdArray = this.pushCompanyDataId;
  //   if (this.pushCompanyDataId.length > 0) {
  //     companyIdArray = this.pushCompanyDataId;
  //   } else {
  //     if (event.target.id == 'replaceLibraryAgendaDoc') {
  //       updateLibraryAgendaDoc = true;
  //     }
  //   }
  //   console.log(updateLibraryAgendaDoc + ' :  updateLibraryAgendaDoc  : ' + companyIdArray);
  //   // ===== Replace Library Agenda Doc END =======

  //   this.isClickedOnce = true;
  //   this.agendaAddForm.controls.agendaCompliance.setValue(varagendaCompliance);
  //   var agendaNumber = this.agendaAddForm.controls.agendaNumber.value;
  //   var IscategorySelected = this.agendaAddForm.controls.IscategorySelected.value;//added Field
  //   var IsMeetingAssigned = this.agendaAddForm.controls.IsMeetingAssigned.value;//added Field
  //   var meetingType = this.agendaAddForm.controls.meetingType.value;
  //   var selectCategory = this.agendaAddForm.controls.selectCategory.value;//Modified added field
  //   var meeting = this.agendaAddForm.controls.meeting.value;// added field
  //   var agendaTitle = this.agendaAddForm.controls.agendaTitle.value;
  //   var agendaCompliance = this.agendaAddedTaskList;
  //   var libaryType;
  //   var agendaType;
  //   var indexGrouping_id = this.agendaAddForm.controls.indexGrouping_id.value;
  //   if (IscategorySelected == 'No') { libaryType = 'Non-Library'; this.agendaAddForm.controls.selectCategory.setValue("null"); selectCategory = null; }
  //   if (IsMeetingAssigned == 'No') { agendaType = 'Open'; this.agendaAddForm.controls.meeting.setValue("null"); meeting = null; }
  //   if (IscategorySelected == 'Yes') { libaryType = 'Library'; }
  //   if (IsMeetingAssigned == 'Yes') { agendaType = 'Non-Open'; }


  //   if ((IsMeetingAssigned == 'Yes' && (meeting == null || meeting == "null")) || (IscategorySelected == 'Yes' && (selectCategory == null || selectCategory == "null"))) {

  //     if (IscategorySelected == 'Yes' && (selectCategory == null || selectCategory == "null")) {
  //       this.booleanCategoryValidate = true;

  //     } else {
  //       this.booleanCategoryValidate = false;
  //     }
  //     if ((IsMeetingAssigned == 'Yes' && (meeting == null || meeting == "null"))) {
  //       this.booleanMeetingValidate = true;

  //     } else {
  //       this.booleanMeetingValidate = false;
  //     }

  //     return false;
  //   }
  //   // if (inputMime == "pdf" || inputMime == "PDF") {
  //   //   this.filesToUpload = undefined
  //   //   this.alert.error('Please upload PDF file from Agenda List screen after saving this agenda');
  //   // } else {
  //     if (this.imageAdd || this.minuteDocAdd) {
  //       // if (inputMime == "docx" || inputMime == "") {
  //         this.makeFileRequest(environment.pssUrl + "agenda/UploadFiles", [], file, agendaTitle, meetingType).then((result) => {
  //           this.uploadMinuteDcoument(this.agendaAddForm.controls.agendaTitle.value, this.agendaAddForm.controls.meetingType.value);
  //           if (this.AddNewAgendafiles) {
  //             this.FileNameOrignalDisplay.push(this.previousAgendafileoriginal);
  //             this.FileChangedName.push(this.previousAgendafilename);
  //           }
  //           console.log(this.AddNewAgendafiles)
  //           console.log(this.FileChangedName)
  //           this.agendaAddForm.controls.image.setValue(this.changedName);
  //           if (this.documentArr.length > 0 && this.documentArrMinDoc.length > 0) {
  //             console.log('test-------2222222')
  //             this.agendaService.updateAgendaDocumentInDB(this.documentArr).subscribe(documentData => {
  //               this.disabledOnclick = false;
  //               console.log(documentData);
  //               console.log(documentData.Data.Filename);
  //               console.log(documentData.Data._id);
  //               for (var index = 0; index < documentData.Data.length; index++) {
  //                 var obj = { 'FileName': documentData.Data[index].Filename, 'DocumentManagementID': documentData.Data[index]._id }
  //                 this.agendaFiles.push(obj);
  //               }

  //               this.agendaService.updateAgendaDocumentInDB(this.documentArrMinDoc).subscribe(documentDataMinDoc => {
  //                 for (var index = 0; index < documentDataMinDoc.Data.length; index++) {
  //                   var obj = { 'FileName': documentDataMinDoc.Data[index].Filename, 'DocumentManagementID': documentDataMinDoc.Data[index]._id }
  //                   this.MinDocFiles.push(obj);
  //                 }


  //                 this.PreambleAndResolution_DocId = documentData.Data[0]._id;
  //                 var newAgenda = {
  //                   _id: this.agendaId,
  //                   agendaNumber: this.agendaAddForm.controls.agendaNumber.value,
  //                   meetingType: this.agendaAddForm.controls.meetingType.value,
  //                   selectCategory: this.agendaAddForm.controls.selectCategory.value,
  //                   agendaTitle: this.agendaAddForm.controls.agendaTitle.value,
  //                   // name : new FormControl('',[]),
  //                   processes: this.addedProcess,
  //                   IscategorySelected: IscategorySelected,
  //                   IsMeetingAssigned: IsMeetingAssigned,
  //                   meetingID: meeting,
  //                   libaryType: libaryType,
  //                   agendaType: agendaType,
  //                   isChangeToMeeting: this.isChangeToMeeting,
  //                   agendaCompliance: this.agendaAddedTaskList,
  //                   image: this.agendaAddForm.controls.image.value,
  //                   orinalFile: this.FileNameOrignalDisplay,
  //                   Upload: this.FileChangedName,
  //                   deletedProcesses: this.deletedProcesses,
  //                   deletedTasks: this.deletedTasks,
  //                   CreatedBy: '',
  //                   CreatedDate: new Date(),
  //                   ModifiedBy: '',
  //                   ModifiedDate: '',
  //                   AgendaFiles: this.agendaFiles,
  //                   agendaNumberPrefix: this.agendaAddForm.controls.agendaNumberPrefix.value,
  //                   PreambleAndResolution_DocId: this.PreambleAndResolution_DocId,
  //                   MinDocFiles: this.MinDocFiles,
  //                   MinuteDocument_DocId: documentDataMinDoc.Data[0]._id,
  //                   MinuteDocument_fileName: this.FileChangedNameMinDoc,
  //                   indexGrouping_id: indexGrouping_id,
  //                   groupName: this.groupName,
  //                   groupNumber: this.groupNumber,
  //                   updateLibraryAgendaDoc: updateLibraryAgendaDoc,
  //                   companyIdArray: companyIdArray,
  //                   documentType: 'AgendaMinute'
  //                 }

  //                 console.log('newAgenda-=------------', newAgenda);
  //                 this.loading = true;
  //                 this.agendaService.updateAgendaInMeeting(this.assignedMeetingID, newAgenda).subscribe(agenda => {

  //                   if (agenda.status == 0) {
  //                     this.loading = false;
  //                     var fromMeeting = localStorage.getItem('fromMeeting')
  //                     // localStorage.removeItem('fromMeeting');
  //                     if (fromMeeting != undefined || fromMeeting != null) {
  //                       this.alert.successWithOk(agenda.message, '/meeting/edit/' + fromMeeting + '/Agenda');
  //                     } else {
  //                       this.alert.successWithOk(agenda.message, '/agenda')
  //                     }
  //                     //this.alert.successWithOk(agenda.message, '/agenda')
  //                   }
  //                   else {
  //                     this.loading = false;
  //                     this.alert.error(agenda.message);
  //                   }
  //                 });

  //               })
  //             });
  //           }
  //           else if (this.documentArr.length > 0) {
  //             this.agendaService.updateAgendaDocumentInDB(this.documentArr).subscribe(documentData => {
  //               console.log(documentData);
  //               console.log(documentData.Data.Filename);
  //               console.log(documentData.Data._id);
  //               for (var index = 0; index < documentData.Data.length; index++) {
  //                 var obj = { 'FileName': documentData.Data[index].Filename, 'DocumentManagementID': documentData.Data[index]._id }
  //                 this.agendaFiles.push(obj);
  //               }

  //               var image = this.agendaAddForm.controls.image.value;
  //               this.PreambleAndResolution_DocId = documentData.Data[0]._id;

  //               var newAgenda = {
  //                 _id: this.agendaId,
  //                 agendaNumber: this.agendaAddForm.controls.agendaNumber.value,
  //                 meetingType: this.agendaAddForm.controls.meetingType.value,
  //                 selectCategory: this.agendaAddForm.controls.selectCategory.value,
  //                 agendaTitle: this.agendaAddForm.controls.agendaTitle.value,
  //                 // name : new FormControl('',[]),
  //                 processes: this.addedProcess,
  //                 IscategorySelected: IscategorySelected,
  //                 IsMeetingAssigned: IsMeetingAssigned,
  //                 meetingID: meeting,
  //                 libaryType: libaryType,
  //                 agendaType: agendaType,
  //                 isChangeToMeeting: this.isChangeToMeeting,
  //                 agendaCompliance: this.agendaAddedTaskList,
  //                 image: this.agendaAddForm.controls.image.value,
  //                 orinalFile: this.FileNameOrignalDisplay,
  //                 Upload: this.FileChangedName,
  //                 deletedProcesses: this.deletedProcesses,
  //                 deletedTasks: this.deletedTasks,
  //                 CreatedBy: '',
  //                 CreatedDate: new Date(),
  //                 ModifiedBy: '',
  //                 ModifiedDate: '',
  //                 AgendaFiles: this.agendaFiles,
  //                 agendaNumberPrefix: this.agendaAddForm.controls.agendaNumberPrefix.value,
  //                 PreambleAndResolution_DocId: this.PreambleAndResolution_DocId,
  //                 indexGrouping_id: indexGrouping_id,
  //                 groupName: this.groupName,
  //                 groupNumber: this.groupNumber,
  //                 MinuteDocument_fileName: this.FileUnchangedNameMinDoc,
  //                 MinuteDocument_DocId: this.minutesDocId,
  //                 updateLibraryAgendaDoc: updateLibraryAgendaDoc,
  //                 companyIdArray: companyIdArray,
  //                 documentType: 'Agenda'
  //               }

  //               console.log('newAgenda-=------------', newAgenda);
  //               this.loading = true;
  //               this.agendaService.updateAgendaInMeeting(this.assignedMeetingID, newAgenda).subscribe(agenda => {

  //                 if (agenda.status == 0) {
  //                   this.loading = false;
  //                   var fromMeeting = localStorage.getItem('fromMeeting')
  //                   // localStorage.removeItem('fromMeeting');

  //                   if (fromMeeting != undefined || fromMeeting != null) {
  //                     this.alert.successWithOk(agenda.message, '/meeting/edit/' + fromMeeting + '/Agenda');
  //                   } else {
  //                     this.alert.successWithOk(agenda.message, '/agenda')
  //                   }
  //                   //this.alert.successWithOk(agenda.message, '/agenda')
  //                 }
  //                 else {
  //                   this.loading = false;
  //                   this.alert.error(agenda.message);
  //                 }
  //               });

  //             })
  //           } else if (this.documentArrMinDoc.length > 0) {

  //             this.agendaService.updateAgendaDocumentInDB(this.documentArrMinDoc).subscribe(documentDataMinDoc => {
  //               for (var index = 0; index < documentDataMinDoc.Data.length; index++) {
  //                 var obj = { 'FileName': documentDataMinDoc.Data[index].Filename, 'DocumentManagementID': documentDataMinDoc.Data[index]._id }
  //                 this.MinDocFiles.push(obj);
  //               }

  //               this.FileChangedName.push(this.previousAgendafilename);
  //               this.FileNameOrignalDisplay.push(this.previousAgendafileoriginal);
  //               var varagendaCompliance = $('.select2').val();
  //               this.agendaAddForm.controls.agendaCompliance.setValue(varagendaCompliance);
  //               // this.agendaAddForm.controls.image.setValue(this.changedName);
  //               var image = this.agendaAddForm.controls.image.value;
  //               var newAgenda = {
  //                 _id: this.agendaId,
  //                 agendaNumber: this.agendaAddForm.controls.agendaNumber.value,
  //                 meetingType: this.agendaAddForm.controls.meetingType.value,
  //                 selectCategory: this.agendaAddForm.controls.selectCategory.value,
  //                 agendaTitle: this.agendaAddForm.controls.agendaTitle.value,
  //                 agendaCompliance: this.agendaAddedTaskList,
  //                 processes: this.addedProcess,
  //                 IscategorySelected: IscategorySelected,
  //                 IsMeetingAssigned: IsMeetingAssigned,
  //                 meetingID: meeting,
  //                 libaryType: libaryType,
  //                 agendaType: agendaType,
  //                 orinalFile: this.FileNameOrignalDisplay,
  //                 Upload: this.FileChangedName,
  //                 image: this.agendaAddForm.controls.image.value,
  //                 CreatedBy: '',
  //                 CreatedDate: new Date(),
  //                 ModifiedBy: '',
  //                 ModifiedDate: '',
  //                 AgendaFiles: this.agendaFiles,
  //                 MinDocFiles: this.MinDocFiles,
  //                 agendaNumberPrefix: this.agendaAddForm.controls.agendaNumberPrefix.value,
  //                 MinuteDocument_DocId: documentDataMinDoc.Data[0]._id,
  //                 MinuteDocument_fileName: this.FileChangedNameMinDoc,
  //                 indexGrouping_id: indexGrouping_id,
  //                 groupName: this.groupName,
  //                 groupNumber: this.groupNumber,
  //                 PreambleAndResolution_DocId: this.PreambleAndResolution_DocId,
  //                 updateLibraryAgendaDoc: updateLibraryAgendaDoc,
  //                 companyIdArray: companyIdArray,
  //                 documentType: 'Minute'
  //               }
  //               console.log('newAgenda------------', newAgenda);
  //               this.loading = true;
  //               this.agendaService.updateAgendaInMeeting(this.assignedMeetingID, newAgenda).subscribe(agenda => {
  //                 // if (agenda.status == 0) {
  //                 //   if (this.FromMeetingmeetingID != undefined || this.FromMeetingmeetingID != null) {
  //                 //     this.alert.successWithOk(agenda.message, '/meeting/edit/' + this.FromMeetingmeetingID + '/Agenda');
  //                 //   } else {
  //                 //     this.alert.successWithOk(agenda.message, '/agenda')
  //                 //   }
  //                 // }
  //                 if (agenda.status == 0) {
  //                   this.loading = false;
  //                   var fromMeeting = localStorage.getItem('fromMeeting')
  //                   // localStorage.removeItem('fromMeeting');

  //                   if (fromMeeting != undefined || fromMeeting != null) {
  //                     this.alert.successWithOk(agenda.message, '/meeting/edit/' + fromMeeting + '/Agenda');
  //                   } else {
  //                     this.alert.successWithOk(agenda.message, '/agenda')
  //                   }
  //                   //this.alert.successWithOk(agenda.message, '/agenda')
  //                 }
  //                 else {
  //                   this.loading = false;
  //                   this.alert.error(agenda.message);
  //                 }
  //               });
  //             });


  //           } else {
  //             var image = this.agendaAddForm.controls.image.value;
  //             this.FileNameOrignalDisplay = this.filenameoriginal;
  //             this.FileChangedName = this.filenamedit;

  //             var newAgenda = {
  //               _id: this.agendaId,
  //               agendaNumber: this.agendaAddForm.controls.agendaNumber.value,
  //               meetingType: this.agendaAddForm.controls.meetingType.value,
  //               selectCategory: this.agendaAddForm.controls.selectCategory.value,
  //               agendaTitle: this.agendaAddForm.controls.agendaTitle.value,
  //               // name : new FormControl('',[]),
  //               processes: this.addedProcess,
  //               IscategorySelected: IscategorySelected,
  //               IsMeetingAssigned: IsMeetingAssigned,
  //               meetingID: meeting,
  //               libaryType: libaryType,
  //               agendaType: agendaType,
  //               isChangeToMeeting: this.isChangeToMeeting,
  //               agendaCompliance: this.agendaAddedTaskList,
  //               image: this.agendaAddForm.controls.image.value,
  //               orinalFile: this.FileNameOrignalDisplay,
  //               Upload: this.FileChangedName,
  //               deletedProcesses: this.deletedProcesses,
  //               deletedTasks: this.deletedTasks,
  //               CreatedBy: '',
  //               CreatedDate: new Date(),
  //               ModifiedBy: '',
  //               ModifiedDate: '',
  //               AgendaFiles: this.agendaFiles,
  //               agendaNumberPrefix: this.agendaAddForm.controls.agendaNumberPrefix.value,
  //               PreambleAndResolution_DocId: this.PreambleAndResolution_DocId,
  //               indexGrouping_id: indexGrouping_id,
  //               groupName: this.groupName,
  //               groupNumber: this.groupNumber,
  //               MinuteDocument_fileName: this.FileUnchangedNameMinDoc,
  //               MinuteDocument_DocId: this.minutesDocId,
  //               updateLibraryAgendaDoc: updateLibraryAgendaDoc,
  //               companyIdArray: companyIdArray,
  //               documentType: 'None'
  //             }

  //             console.log('newAgenda-=------------', newAgenda);
  //             this.loading = true;
  //             this.agendaService.updateAgendaInMeeting(this.assignedMeetingID, newAgenda).subscribe(agenda => {

  //               if (agenda.status == 0) {
  //                 this.loading = false;
  //                 var fromMeeting = localStorage.getItem('fromMeeting')
  //                 // localStorage.removeItem('fromMeeting');

  //                 if (fromMeeting != undefined || fromMeeting != null) {
  //                   this.alert.successWithOk(agenda.message, '/meeting/edit/' + fromMeeting + '/Agenda');
  //                 } else {
  //                   this.alert.successWithOk(agenda.message, '/agenda')
  //                 }
  //                 //this.alert.successWithOk(agenda.message, '/agenda')
  //               }
  //               else {
  //                 this.loading = false;
  //                 this.alert.error(agenda.message);
  //               }
  //             });
  //           }
  //         }, (error) => {
  //           console.log(error)
  //           var fromMeeting = localStorage.getItem('fromMeeting')
  //           this.alert.successWithOk('Invalid File', '/meeting/edit/' + fromMeeting + '/Agenda');
  //           // this.alert.error('Invalid File');
  //         })
  //       // } else {
  //       //   this.filesToUpload = undefined
  //       //   this.alert.error('Please upload PDF file from Agenda List screen after saving this agenda');
  //       // }
  //       var file = this.filesToUpload;


  //     } else {
  //       this.FileNameOrignalDisplay = this.filenameoriginal;
  //       this.FileChangedName = this.filenamedit;

  //       var image = this.agendaAddForm.controls.image.value;


  //       var newAgenda1 = {
  //         _id: this.agendaId,
  //         agendaNumber: this.agendaAddForm.controls.agendaNumber.value,
  //         meetingType: this.agendaAddForm.controls.meetingType.value,
  //         selectCategory: this.agendaAddForm.controls.selectCategory.value,
  //         agendaTitle: this.agendaAddForm.controls.agendaTitle.value,
  //         // name : new FormControl('',[]),
  //         processes: this.addedProcess,
  //         IscategorySelected: IscategorySelected,
  //         IsMeetingAssigned: IsMeetingAssigned,
  //         meetingID: meeting,
  //         libaryType: libaryType,
  //         agendaType: agendaType,
  //         isChangeToMeeting: this.isChangeToMeeting,
  //         agendaCompliance: this.agendaAddedTaskList,
  //         image: this.agendaAddForm.controls.image.value,
  //         orinalFile: this.FileNameOrignalDisplay,
  //         Upload: this.FileChangedName,
  //         deletedProcesses: this.deletedProcesses,
  //         deletedTasks: this.deletedTasks,
  //         CreatedBy: '',
  //         CreatedDate: new Date(),
  //         ModifiedBy: '',
  //         ModifiedDate: '',
  //         AgendaFiles: this.agendaFiles,
  //         agendaNumberPrefix: this.agendaAddForm.controls.agendaNumberPrefix.value,
  //         PreambleAndResolution_DocId: this.PreambleAndResolution_DocId,
  //         indexGrouping_id: indexGrouping_id,
  //         groupName: this.groupName,
  //         groupNumber: this.groupNumber,
  //         MinuteDocument_fileName: this.FileUnchangedNameMinDoc,
  //         MinuteDocument_DocId: this.minutesDocId,
  //         updateLibraryAgendaDoc: updateLibraryAgendaDoc,
  //         companyIdArray: companyIdArray,
  //         documentType: 'None'
  //       }

  //       console.log('newAgenda-=------------', newAgenda1);
  //       this.loading = true;
  //       this.agendaService.updateAgendaInMeeting(this.assignedMeetingID, newAgenda1).subscribe(agenda => {
  //         this.disabledOnclick = false;
  //         if (agenda.status == 0) {
  //           this.loading = false;
  //           var fromMeeting = localStorage.getItem('fromMeeting')
  //           // localStorage.removeItem('fromMeeting');

  //           if (fromMeeting != undefined || fromMeeting != null) {
  //             this.alert.successWithOk(agenda.message, '/meeting/edit/' + fromMeeting + '/Agenda');
  //           } else {
  //             this.alert.successWithOk(agenda.message, '/agenda')
  //           }
  //           //this.alert.successWithOk(agenda.message, '/agenda')
  //         }
  //         else {
  //           this.loading = false;
  //           this.alert.error(agenda.message);
  //         }
  //       });
  //     }
  //   //}

  // }

  updateAgenda(event) {
    this.disabledOnclick = true;
    var varagendaCompliance = $('.select2').val();
    // alert(varagendaCompliance);
    //console.log('file name--->',this.agendaAddForm.controls.image.value);
    // ===== Replace Library Agenda Doc START =======
    var updateLibraryAgendaDoc = false;
    var companyIdArray = this.pushCompanyDataId;
    if (this.pushCompanyDataId.length > 0) {
      companyIdArray = this.pushCompanyDataId;
    } else {
      if (event.target.id == 'replaceLibraryAgendaDoc') {
        updateLibraryAgendaDoc = true;
      }
    }
    console.log(updateLibraryAgendaDoc + ' :  updateLibraryAgendaDoc  : ' + companyIdArray);
    // ===== Replace Library Agenda Doc END =======

    this.isClickedOnce = true;
    this.agendaAddForm.controls.agendaCompliance.setValue(varagendaCompliance);
    var agendaNumber = this.agendaAddForm.controls.agendaNumber.value;
    var IscategorySelected = this.agendaAddForm.controls.IscategorySelected.value;//added Field
    var IsMeetingAssigned = this.agendaAddForm.controls.IsMeetingAssigned.value;//added Field
    var meetingType = this.agendaAddForm.controls.meetingType.value;
    var selectCategory = this.agendaAddForm.controls.selectCategory.value;//Modified added field
    var meeting = this.agendaAddForm.controls.meeting.value;// added field
    var agendaTitle = this.agendaAddForm.controls.agendaTitle.value;
    var agendaCompliance = this.agendaAddedTaskList;
    var department = this.agendaAddForm.controls.department;
    var agendaTypeSelection = this.agendaAddForm.controls.agendaType;
    var libaryType;
    var agendaType;
    var indexGrouping_id = this.agendaAddForm.controls.indexGrouping_id.value;
    if (IscategorySelected == 'No') { libaryType = 'Non-Library'; this.agendaAddForm.controls.selectCategory.setValue("null"); selectCategory = null; }
    if (IsMeetingAssigned == 'No') { agendaType = 'Open'; this.agendaAddForm.controls.meeting.setValue("null"); meeting = null; }
    if (IscategorySelected == 'Yes') { libaryType = 'Library'; }
    if (IsMeetingAssigned == 'Yes') { agendaType = 'Non-Open'; }


    if ((IsMeetingAssigned == 'Yes' && (meeting == null || meeting == "null")) || (IscategorySelected == 'Yes' && (selectCategory == null || selectCategory == "null"))) {

      if (IscategorySelected == 'Yes' && (selectCategory == null || selectCategory == "null")) {
        this.booleanCategoryValidate = true;

      } else {
        this.booleanCategoryValidate = false;
      }
      if ((IsMeetingAssigned == 'Yes' && (meeting == null || meeting == "null"))) {
        this.booleanMeetingValidate = true;

      } else {
        this.booleanMeetingValidate = false;
      }

      return false;
    }
    if (this.imageAdd || this.minuteDocAdd) {
      //console.log('this.imageAdd',this.imageAdd);
      // this.upload(this.agendaAddForm.controls.agendaTitle.value, this.agendaAddForm.controls.meetingType.value);
      var file = this.filesToUpload;
      this.makeFileRequest(environment.pssUIBaseUrl + "agenda/UploadFiles", [], file, agendaTitle, meetingType).then((result) => {
        this.uploadMinuteDcoument(this.agendaAddForm.controls.agendaTitle.value, this.agendaAddForm.controls.meetingType.value);
        if (this.AddNewAgendafiles) {
          this.FileNameOrignalDisplay.push(this.previousAgendafileoriginal);
          this.FileChangedName.push(this.previousAgendafilename);
        }
        console.log(this.AddNewAgendafiles)
        console.log(this.FileChangedName)
        this.agendaAddForm.controls.image.setValue(this.changedName);
        if (this.documentArr.length > 0 && this.documentArrMinDoc.length > 0) {
          console.log('test-------2222222')
          this.agendaService.updateAgendaDocumentInDB(this.documentArr).subscribe(documentData => {
            this.disabledOnclick = false;
            console.log(documentData);
            console.log(documentData.Data.Filename);
            console.log(documentData.Data._id);
            for (var index = 0; index < documentData.Data.length; index++) {
              var obj = { 'FileName': documentData.Data[index].Filename, 'DocumentManagementID': documentData.Data[index]._id }
              this.agendaFiles.push(obj);
            }

            this.agendaService.updateAgendaDocumentInDB(this.documentArrMinDoc).subscribe(documentDataMinDoc => {
              for (var index = 0; index < documentDataMinDoc.Data.length; index++) {
                var obj = { 'FileName': documentDataMinDoc.Data[index].Filename, 'DocumentManagementID': documentDataMinDoc.Data[index]._id }
                this.MinDocFiles.push(obj);
              }


              this.PreambleAndResolution_DocId = documentData.Data[0]._id;
              var newAgenda = {
                _id: this.agendaId,
                agendaNumber: this.agendaAddForm.controls.agendaNumber.value,
                meetingType: this.agendaAddForm.controls.meetingType.value,
                selectCategory: this.agendaAddForm.controls.selectCategory.value,
                agendaTitle: this.agendaAddForm.controls.agendaTitle.value,
                // name : new FormControl('',[]),
                processes: this.addedProcess,
                IscategorySelected: IscategorySelected,
                IsMeetingAssigned: IsMeetingAssigned,
                meetingID: meeting,
                libaryType: libaryType,
                agendaType: agendaType,
                agendaTypeSelection: this.agendaAddForm.controls.agendaType.value,
                department: this.agendaAddForm.controls.department.value,
                isChangeToMeeting: this.isChangeToMeeting,
                agendaCompliance: this.agendaAddedTaskList,
                image: this.agendaAddForm.controls.image.value,
                orinalFile: this.FileNameOrignalDisplay,
                Upload: this.FileChangedName,
                deletedProcesses: this.deletedProcesses,
                deletedTasks: this.deletedTasks,
                CreatedBy: '',
                CreatedDate: new Date(),
                ModifiedBy: '',
                ModifiedDate: '',
                AgendaFiles: this.agendaFiles,
                agendaNumberPrefix: this.agendaAddForm.controls.agendaNumberPrefix.value,
                PreambleAndResolution_DocId: this.PreambleAndResolution_DocId,
                MinDocFiles: this.MinDocFiles,
                MinuteDocument_DocId: documentDataMinDoc.Data[0]._id,
                MinuteDocument_fileName: this.FileChangedNameMinDoc,
                indexGrouping_id: indexGrouping_id,
                groupName: this.groupName,
                groupNumber: this.groupNumber,
                updateLibraryAgendaDoc: updateLibraryAgendaDoc,
                companyIdArray: companyIdArray,
                documentType: 'AgendaMinute'
              }

              console.log('newAgenda-=------------', newAgenda);
              this.loading = true;
              this.agendaService.updateAgendaInMeeting(this.assignedMeetingID, newAgenda).subscribe(agenda => {

                if (agenda.status == 0) {
                  this.loading = false;
                  var fromMeeting = localStorage.getItem('fromMeeting')
                  // localStorage.removeItem('fromMeeting');
                  if (fromMeeting != undefined || fromMeeting != null) {
                     this.alert.successWithOk1(agenda.message, ()=>{this.router.navigate(
                [{ outlets: { 'structure-outlet': ['addMeetings', 'edit',fromMeeting,'Agenda'] } }],
                { relativeTo: this.route.parent });});
                    // this.alert.successWithOk(agenda.message, '/meeting/edit/' + fromMeeting + '/Agenda');
                  } else {
                    this.alert.successWithOk1(agenda.message, ()=>{this.router.navigate(
                [{ outlets: { 'structure-outlet': ['agenda'] } }],
                { relativeTo: this.route.parent });});
                    // this.alert.successWithOk(agenda.message, '/agenda')
                  }
                  //this.alert.successWithOk(agenda.message, '/agenda')
                } else if (agenda.status == 55) {
                  this.loading = false;
                  this.meetingService.downloadSplitFailureFile(agenda.filename);
                  var fromMeeting = localStorage.getItem('fromMeeting')
                  // localStorage.removeItem('fromMeeting');
                  if (fromMeeting != undefined || fromMeeting != null) {
                    this.alert.error(agenda.message);
                    //this.alert.successWithOk(agenda.message, '/meeting/edit/' + fromMeeting + '/Agenda');
                  } else {
                    this.alert.error(agenda.message);
                    //this.alert.successWithOk(agenda.message, '/agenda')
                  }
                }
                else {
                  this.loading = false;
                  this.alert.error(agenda.message);
                }
              });

            })
          });
        }
        else if (this.documentArr.length > 0) {
          this.agendaService.updateAgendaDocumentInDB(this.documentArr).subscribe(documentData => {
            console.log(documentData);
            console.log(documentData.Data.Filename);
            console.log(documentData.Data._id);
            for (var index = 0; index < documentData.Data.length; index++) {
              var obj = { 'FileName': documentData.Data[index].Filename, 'DocumentManagementID': documentData.Data[index]._id }
              this.agendaFiles.push(obj);
            }

            var image = this.agendaAddForm.controls.image.value;
            this.PreambleAndResolution_DocId = documentData.Data[0]._id;

            var newAgenda = {
              _id: this.agendaId,
              agendaNumber: this.agendaAddForm.controls.agendaNumber.value,
              meetingType: this.agendaAddForm.controls.meetingType.value,
              selectCategory: this.agendaAddForm.controls.selectCategory.value,
              agendaTitle: this.agendaAddForm.controls.agendaTitle.value,
              // name : new FormControl('',[]),
              processes: this.addedProcess,
              IscategorySelected: IscategorySelected,
              IsMeetingAssigned: IsMeetingAssigned,
              meetingID: meeting,
              libaryType: libaryType,
              agendaType: agendaType,
              agendaTypeSelection: this.agendaAddForm.controls.agendaType.value,
              department: this.agendaAddForm.controls.department.value,
              isChangeToMeeting: this.isChangeToMeeting,
              agendaCompliance: this.agendaAddedTaskList,
              image: this.agendaAddForm.controls.image.value,
              orinalFile: this.FileNameOrignalDisplay,
              Upload: this.FileChangedName,
              deletedProcesses: this.deletedProcesses,
              deletedTasks: this.deletedTasks,
              CreatedBy: '',
              CreatedDate: new Date(),
              ModifiedBy: '',
              ModifiedDate: '',
              AgendaFiles: this.agendaFiles,
              agendaNumberPrefix: this.agendaAddForm.controls.agendaNumberPrefix.value,
              PreambleAndResolution_DocId: this.PreambleAndResolution_DocId,
              indexGrouping_id: indexGrouping_id,
              groupName: this.groupName,
              groupNumber: this.groupNumber,
              MinuteDocument_fileName: this.FileUnchangedNameMinDoc,
              MinuteDocument_DocId: this.minutesDocId,
              updateLibraryAgendaDoc: updateLibraryAgendaDoc,
              companyIdArray: companyIdArray,
              documentType: 'Agenda'
            }

            console.log('newAgenda-=------------', newAgenda);
            this.loading = true;
            this.agendaService.updateAgendaInMeeting(this.assignedMeetingID, newAgenda).subscribe(agenda => {

              if (agenda.status == 0) {
                this.loading = false;
                var fromMeeting = localStorage.getItem('fromMeeting')
                // localStorage.removeItem('fromMeeting');

                if (fromMeeting != undefined || fromMeeting != null) {
                    this.alert.successWithOk1(agenda.message, ()=>{this.router.navigate(
                [{ outlets: { 'structure-outlet': ['addMeetings', 'edit',fromMeeting,'Agenda'] } }],
                { relativeTo: this.route.parent });});
                  // this.alert.successWithOk(agenda.message, '/meeting/edit/' + fromMeeting + '/Agenda');
                } else {
                    this.alert.successWithOk1(agenda.message, ()=>{this.router.navigate(
                [{ outlets: { 'structure-outlet': ['agenda'] } }],
                { relativeTo: this.route.parent });});
                  // this.alert.successWithOk(agenda.message, '/agenda')
                }
                //this.alert.successWithOk(agenda.message, '/agenda')
              } else if (agenda.status == 55) {
                this.loading = false;
                this.meetingService.downloadSplitFailureFile(agenda.filename);
                var fromMeeting = localStorage.getItem('fromMeeting')
                // localStorage.removeItem('fromMeeting');
                if (fromMeeting != undefined || fromMeeting != null) {
                  this.alert.error(agenda.message);
                  //this.alert.successWithOk(agenda.message, '/meeting/edit/' + fromMeeting + '/Agenda');
                } else {
                  this.alert.error(agenda.message);
                  //this.alert.successWithOk(agenda.message, '/agenda')
                }
              }
              else {
                this.loading = false;
                this.alert.error(agenda.message);
              }
            });

          })
        } else if (this.documentArrMinDoc.length > 0) {

          this.agendaService.updateAgendaDocumentInDB(this.documentArrMinDoc).subscribe(documentDataMinDoc => {
            for (var index = 0; index < documentDataMinDoc.Data.length; index++) {
              var obj = { 'FileName': documentDataMinDoc.Data[index].Filename, 'DocumentManagementID': documentDataMinDoc.Data[index]._id }
              this.MinDocFiles.push(obj);
            }

            this.FileChangedName.push(this.previousAgendafilename);
            this.FileNameOrignalDisplay.push(this.previousAgendafileoriginal);
            var varagendaCompliance = $('.select2').val();
            this.agendaAddForm.controls.agendaCompliance.setValue(varagendaCompliance);
            // this.agendaAddForm.controls.image.setValue(this.changedName);
            var image = this.agendaAddForm.controls.image.value;
            var newAgenda = {
              _id: this.agendaId,
              agendaNumber: this.agendaAddForm.controls.agendaNumber.value,
              meetingType: this.agendaAddForm.controls.meetingType.value,
              selectCategory: this.agendaAddForm.controls.selectCategory.value,
              agendaTitle: this.agendaAddForm.controls.agendaTitle.value,
              agendaCompliance: this.agendaAddedTaskList,
              processes: this.addedProcess,
              IscategorySelected: IscategorySelected,
              IsMeetingAssigned: IsMeetingAssigned,
              meetingID: meeting,
              libaryType: libaryType,
              agendaType: agendaType,
              agendaTypeSelection: this.agendaAddForm.controls.agendaType.value,
              department: this.agendaAddForm.controls.department.value,
              orinalFile: this.FileNameOrignalDisplay,
              Upload: this.FileChangedName,
              image: this.agendaAddForm.controls.image.value,
              CreatedBy: '',
              CreatedDate: new Date(),
              ModifiedBy: '',
              ModifiedDate: '',
              AgendaFiles: this.agendaFiles,
              MinDocFiles: this.MinDocFiles,
              agendaNumberPrefix: this.agendaAddForm.controls.agendaNumberPrefix.value,
              MinuteDocument_DocId: documentDataMinDoc.Data[0]._id,
              MinuteDocument_fileName: this.FileChangedNameMinDoc,
              indexGrouping_id: indexGrouping_id,
              groupName: this.groupName,
              groupNumber: this.groupNumber,
              PreambleAndResolution_DocId: this.PreambleAndResolution_DocId,
              updateLibraryAgendaDoc: updateLibraryAgendaDoc,
              companyIdArray: companyIdArray,
              documentType: 'Minute'
            }
            console.log('newAgenda------------', newAgenda);
            this.loading = true;
            this.agendaService.updateAgendaInMeeting(this.assignedMeetingID, newAgenda).subscribe(agenda => {
              // if (agenda.status == 0) {
              //   if (this.FromMeetingmeetingID != undefined || this.FromMeetingmeetingID != null) {
              //     this.alert.successWithOk(agenda.message, '/meeting/edit/' + this.FromMeetingmeetingID + '/Agenda');
              //   } else {
              //     this.alert.successWithOk(agenda.message, '/agenda')
              //   }
              // }
              if (agenda.status == 0) {
                this.loading = false;
                var fromMeeting = localStorage.getItem('fromMeeting')
                // localStorage.removeItem('fromMeeting');

                if (fromMeeting != undefined || fromMeeting != null) {
                  this.alert.successWithOk1(agenda.message, ()=>{this.router.navigate(
                [{ outlets: { 'structure-outlet': ['addMeetings', 'edit',fromMeeting,'Agenda'] } }],
                { relativeTo: this.route.parent });});
                  // this.alert.successWithOk(agenda.message, '/meeting/edit/' + fromMeeting + '/Agenda');
                } else {
                  this.alert.successWithOk1(agenda.message, ()=>{this.router.navigate(
                [{ outlets: { 'structure-outlet': ['agenda'] } }],
                { relativeTo: this.route.parent });});
                  // this.alert.successWithOk(agenda.message, '/agenda')
                }
                //this.alert.successWithOk(agenda.message, '/agenda')
              } else if (agenda.status == 55) {
                this.loading = false;
                this.meetingService.downloadSplitFailureFile(agenda.filename);
                var fromMeeting = localStorage.getItem('fromMeeting')
                // localStorage.removeItem('fromMeeting');
                if (fromMeeting != undefined || fromMeeting != null) {
                  this.alert.error(agenda.message);
                  //this.alert.successWithOk(agenda.message, '/meeting/edit/' + fromMeeting + '/Agenda');
                } else {
                  this.alert.error(agenda.message);
                  //this.alert.successWithOk(agenda.message, '/agenda')
                }
              }
              else {
                this.loading = false;
                this.alert.error(agenda.message);
              }
            });
          });


        } else {
          var image = this.agendaAddForm.controls.image.value;
          this.FileNameOrignalDisplay = this.filenameoriginal;
          this.FileChangedName = this.filenamedit;

          var newAgenda = {
            _id: this.agendaId,
            agendaNumber: this.agendaAddForm.controls.agendaNumber.value,
            meetingType: this.agendaAddForm.controls.meetingType.value,
            selectCategory: this.agendaAddForm.controls.selectCategory.value,
            agendaTitle: this.agendaAddForm.controls.agendaTitle.value,
            // name : new FormControl('',[]),
            processes: this.addedProcess,
            IscategorySelected: IscategorySelected,
            IsMeetingAssigned: IsMeetingAssigned,
            meetingID: meeting,
            libaryType: libaryType,
            agendaType: agendaType,
            agendaTypeSelection: this.agendaAddForm.controls.agendaType.value,
            department: this.agendaAddForm.controls.department.value,
            isChangeToMeeting: this.isChangeToMeeting,
            agendaCompliance: this.agendaAddedTaskList,
            image: this.agendaAddForm.controls.image.value,
            orinalFile: this.FileNameOrignalDisplay,
            Upload: this.FileChangedName,
            deletedProcesses: this.deletedProcesses,
            deletedTasks: this.deletedTasks,
            CreatedBy: '',
            CreatedDate: new Date(),
            ModifiedBy: '',
            ModifiedDate: '',
            AgendaFiles: this.agendaFiles,
            agendaNumberPrefix: this.agendaAddForm.controls.agendaNumberPrefix.value,
            PreambleAndResolution_DocId: this.PreambleAndResolution_DocId,
            indexGrouping_id: indexGrouping_id,
            groupName: this.groupName,
            groupNumber: this.groupNumber,
            MinuteDocument_fileName: this.FileUnchangedNameMinDoc,
            MinuteDocument_DocId: this.minutesDocId,
            updateLibraryAgendaDoc: updateLibraryAgendaDoc,
            companyIdArray: companyIdArray,
            documentType: 'None'
          }

          console.log('newAgenda-=------------', newAgenda);
          this.loading = true;
          this.agendaService.updateAgendaInMeeting(this.assignedMeetingID, newAgenda).subscribe(agenda => {

            if (agenda.status == 0) {
              this.loading = false;
              var fromMeeting = localStorage.getItem('fromMeeting')
              // localStorage.removeItem('fromMeeting');

              if (fromMeeting != undefined || fromMeeting != null) {
                 this.alert.successWithOk1(agenda.message, ()=>{this.router.navigate(
                [{ outlets: { 'structure-outlet': ['addMeetings', 'edit',fromMeeting,'Agenda'] } }],
                { relativeTo: this.route.parent });});
                // this.alert.successWithOk(agenda.message, '/meeting/edit/' + fromMeeting + '/Agenda');
              } else {
                 this.alert.successWithOk1(agenda.message, ()=>{this.router.navigate(
                [{ outlets: { 'structure-outlet': ['agenda'] } }],
                { relativeTo: this.route.parent });});
                // this.alert.successWithOk(agenda.message, '/agenda')
              }
              //this.alert.successWithOk(agenda.message, '/agenda')
            } else if (agenda.status == 55) {
              this.loading = false;
              this.meetingService.downloadSplitFailureFile(agenda.filename);
              var fromMeeting = localStorage.getItem('fromMeeting')
              // localStorage.removeItem('fromMeeting');
              if (fromMeeting != undefined || fromMeeting != null) {
                this.alert.error(agenda.message);
                //this.alert.successWithOk(agenda.message, '/meeting/edit/' + fromMeeting + '/Agenda');
              } else {
                this.alert.error(agenda.message);
                //this.alert.successWithOk(agenda.message, '/agenda')
              }
            }
            else {
              this.loading = false;
              this.alert.error(agenda.message);
            }
          });
        }
      }, (error) => {
        var fromMeeting = localStorage.getItem('fromMeeting')
          this.alert.successWithOk1('Invalid File', ()=>{this.router.navigate(
                [{ outlets: { 'structure-outlet': ['addMeetings','edit',+ fromMeeting + 'Agenda'] } }],
                { relativeTo: this.route.parent });});
        // this.alert.successWithOk('Invalid File', '/meeting/edit/' + fromMeeting + '/Agenda');
        // this.alert.error('Invalid File');
      })

    } else {
      this.FileNameOrignalDisplay = this.filenameoriginal;
      this.FileChangedName = this.filenamedit;

      var image = this.agendaAddForm.controls.image.value;


      var newAgenda1 = {
        _id: this.agendaId,
        agendaNumber: this.agendaAddForm.controls.agendaNumber.value,
        meetingType: this.agendaAddForm.controls.meetingType.value,
        selectCategory: this.agendaAddForm.controls.selectCategory.value,
        agendaTitle: this.agendaAddForm.controls.agendaTitle.value,
        // name : new FormControl('',[]),
        processes: this.addedProcess,
        IscategorySelected: IscategorySelected,
        IsMeetingAssigned: IsMeetingAssigned,
        meetingID: meeting,
        libaryType: libaryType,
        agendaType: agendaType,
        agendaTypeSelection: this.agendaAddForm.controls.agendaType.value,
        department: this.agendaAddForm.controls.department.value,
        isChangeToMeeting: this.isChangeToMeeting,
        agendaCompliance: this.agendaAddedTaskList,
        image: this.agendaAddForm.controls.image.value,
        orinalFile: this.FileNameOrignalDisplay,
        Upload: this.FileChangedName,
        deletedProcesses: this.deletedProcesses,
        deletedTasks: this.deletedTasks,
        CreatedBy: '',
        CreatedDate: new Date(),
        ModifiedBy: '',
        ModifiedDate: '',
        AgendaFiles: this.agendaFiles,
        agendaNumberPrefix: this.agendaAddForm.controls.agendaNumberPrefix.value,
        PreambleAndResolution_DocId: this.PreambleAndResolution_DocId,
        indexGrouping_id: indexGrouping_id,
        groupName: this.groupName,
        groupNumber: this.groupNumber,
        MinuteDocument_fileName: this.FileUnchangedNameMinDoc,
        MinuteDocument_DocId: this.minutesDocId,
        updateLibraryAgendaDoc: updateLibraryAgendaDoc,
        companyIdArray: companyIdArray,
        documentType: 'None'
      }

      console.log('newAgenda-=------------', newAgenda1);
      this.loading = true;
      this.agendaService.updateAgendaInMeeting(this.assignedMeetingID, newAgenda1).subscribe(agenda => {
        this.disabledOnclick = false;
        if (agenda.status == 0) {
          this.loading = false;
          var fromMeeting = localStorage.getItem('fromMeeting')
          // localStorage.removeItem('fromMeeting');

          if (fromMeeting != undefined || fromMeeting != null) {
            this.alert.successWithOk1('Invalid File', ()=>{this.router.navigate(
                [{ outlets: { 'structure-outlet': ['addMeetings','edit',+ fromMeeting + 'Agenda'] } }],
                { relativeTo: this.route.parent });});
            // this.alert.successWithOk(agenda.message, '/meeting/edit/' + fromMeeting + '/Agenda');
          } else {
            this.alert.successWithOk1('Invalid File', ()=>{this.router.navigate(
                [{ outlets: { 'structure-outlet': ['agenda'] } }],
                { relativeTo: this.route.parent });});
            // this.alert.successWithOk(agenda.message, '/agenda')
          }
          //this.alert.successWithOk(agenda.message, '/agenda')
        }
        else {
          this.loading = false;
          this.alert.error(agenda.message);
        }
      });
    }
    // console.log('this.imageAdd', this.imageAdd);
    // var varagendaCompliance = $('.select2').val();



  }

  downloadDoc() {
    console.log(window.location.href);
    var lastSegOfURL = window.location.href.substr(window.location.href.lastIndexOf('/') + 1);
    console.log(lastSegOfURL);
    console.log(localStorage.getItem('fromMeeting'));
    this.agendaService.downloadLibraryAgendaDOCS(localStorage.getItem('fromMeeting'), lastSegOfURL, 'Agenda').subscribe((data:any) => {
      // var blob = new Blob([data]);
      // var url = window.URL.createObjectURL(blob);
      // console.log(data.url),
      window.open(data.url);
    }),//console.log(data),
      error => console.log("Error downloading the file."),
      () => console.info("OK");
  }

  downloadMinDoc() {
    // this.downloadSingleFile = environment.pssUrl + 'documentManagement/downloadSingleFileOnID/';
    // window.location.href = this.downloadSingleFile + this.minutesDocId + '/' + this.token;

    console.log(window.location.href);
    var lastSegOfURL = window.location.href.substr(window.location.href.lastIndexOf('/') + 1);
    console.log(lastSegOfURL);
    console.log(localStorage.getItem('fromMeeting'));
    this.agendaService.downloadLibraryAgendaDOCS(localStorage.getItem('fromMeeting'), lastSegOfURL, 'Minute').subscribe((data:any) => {
      // var blob = new Blob([data]);
      // var url = window.URL.createObjectURL(blob);
      // console.log(data.url),
      window.open(data.url);
    }),//console.log(data),
      error => console.log("Error downloading the file."),
      () => console.info("OK");

  }

  downloadAll() {
    var lastSegOfURL = window.location.href.substr(window.location.href.lastIndexOf('/') + 1);
    window.location.href = this.downloadAllLink + localStorage.getItem('fromMeeting') + '/' + lastSegOfURL;
  }

  meetingDateOnSelectedType: any[];
  getMeetingFromType(meetingTypeId) {
    this.meetingTypeID = meetingTypeId;
    this.agendaAddForm.controls.meeting.setValue(null);
    // console.log(meetingTypeId);
    this.agendaService.getMeetingOnTypeSelect(meetingTypeId).subscribe(data => {
      // console.log('data',data.meetingData)
      if (data.meetingData.length > 0) {
        if (data.status == 0) {
          console.log('data---->>', data);
          //  this.meetingDateOnSelectedType = this.commonFunction.sortByKey(data.meetingData, 'MeetingDate');
          this.meetingDateOnSelectedType = data.meetingData;

        }
      } else {
        this.meetingDateOnSelectedType = []
        this.agendaAddForm.controls.meeting.setValue(null);
      }
    });
    this.processes = [];
    this.onAddProcessModelPopUpEvent();
    this.getCategoryListOnBehalfOfMeeting(meetingTypeId);
  }

  getCategoryListOnBehalfOfMeeting(meetingTypeId) {
    this.categories = [];
    this.categoryMasterService.getCategoryListByMeetingTypeID(meetingTypeId)
      .subscribe(categoryList => {
        console.log(categoryList);
        if (categoryList.status == 0) {
          this.categories = this.commonFunction.sortByKey(categoryList.categoryList, 'CategoryName');
        }
      });
  }


  showAddPopUp() {
    $("#myModalLabel").html('<i class="fa fa-plus"></i>Add Category');
    // $("#myModalLabel").text("Add Category Master");
    $('#btnsaveCategory').show();
    $('#btnupdateCategory').hide();
    $('#isDefaultYes').prop("disabled", false);
    $('#isDefaultNo').prop("disabled", false);
    this.categoryMasterForm.controls.CategoryName.setValue('');
    this.categoryMasterForm.controls.MeetingType.setValue('');
    this.categoryMasterForm.controls.IsGlobal.setValue('Company');
    this.categoryMasterForm.controls.isDefault.setValue('false');
    // this.error = { isError: false, errorMessage: '' }
    setTimeout(function () {
      $(".radio").focus();
    }, 500);

  }

  showAddPopUpIndexGroup() {
    this.GroupingNumberTouched = false;
    this.GroupingNameTouched = false;
    $("#myModalLabel").html('<i class="fa fa-plus"></i>Add Category');
    // $("#myModalLabel").text("Add Category Master");
    $('#btnsaveCategory').show();
    $('#btnupdateCategory').hide();
    this.categoryMasterForm.controls.CategoryName.setValue('');
    this.categoryMasterForm.controls.MeetingType.setValue('');
    this.categoryMasterForm.controls.IsGlobal.setValue('Company');
    // this.error = { isError: false, errorMessage: '' }
    setTimeout(function () {
      $(".radio").focus();
    }, 500);

  }


  addCategory() {
    this.disabledOnclick = true;
    if (this.categoryMasterForm.status == "VALID") {
      // debugger
      var checkGlobal = true;
      var checkDefault = true;
      if (this.categoryMasterForm.controls.IsGlobal.value == 'Company') {
        checkGlobal = false
      }
      if (this.categoryMasterForm.controls.isDefault.value == 'false') {
        checkDefault = false;
      }
      var newCategory = {
        IsGlobal: checkGlobal,
        isDefault: checkDefault,
        CategoryName: this.categoryMasterForm.controls.CategoryName.value.trim(),
        MeetingTypeID: this.categoryMasterForm.controls.MeetingType.value
        //CompanyID:"5a3778b4323b0a2a5839474b"
      }
      this.categoryMasterService.addCategory(newCategory)
        .subscribe(category => {
          this.disabledOnclick = false;
          if (category.status == 0) {
            $('#categoryDialog').modal('toggle');
            this.alert.success("Category created successfully.");
            this.getCategoryListOnBehalfOfMeeting(this.meetingTypeID);
            // this.getCategoryList();
          } else {
            $('#categoryDialog').modal('toggle');
            this.alert.error(category.message);
          }

          this.categoryMasterForm.reset();

        });
    }
    else {
      // console.log('Invalid form submit.')
      return false;
    }
  }

  regiserModalShowEvent() {
    $('#AddCompliancesDialog').on('shown.bs.modal', function (e) {
      $('#companytaskTable').DataTable().columns.adjust();
    })
  }


  processError = {
    message: "Please select Meeting Type First",
    hasError: true
  };

  onAddProcessModelPopUpEvent() {
    var meetingTypeID = this.meetingTypeID;
    console.log(this.meetingTypeID);
    console.log(meetingTypeID)
    if (meetingTypeID == undefined || meetingTypeID == undefined || meetingTypeID == null || meetingTypeID == "null") {
      this.processError.hasError = true;
      this.processError.message = "Please select Meeting Type First"
    } else {

      $("#processTablePopup").DataTable().destroy();
      this.processes = [];

      this.processError.hasError = false;
      this.processMasterService.getProcessList()
        .subscribe(data => {
          if (data.status == 0) {
            var data = data.processList;
            var processesData = [];
            data.forEach(element => {
              element.IsSelected = false;
              if (element.MeetingTypeId != meetingTypeID) {
                processesData.push(element);
              }
            });
            this.processes = processesData;
            for (var j = 0; j < this.addedProcess.length; j++) {
              var index = this.indexOfElementArray(this.processes, this.addedProcess[j]);
              // console.log(index);
              this.processes.splice(index, 1);
            }
            this.dtTriggerProcessAddingPopup.next();
          }
        })
      // // $("processTablePopup").DataTable().destroy();

      // this.processMasterService.getProcessList()
      //   .subscribe(processList => {
      //     if (processList.status == 0) {
      //       var processData= processList.processList;

      //       processData.forEach(element => {
      //         element.IsSelected = false;
      //       //   var i = 0;
      //       //   if (element.MeetingTypeId == this.meetingTypeID) {

      //       //     this.processes.splice(i, 1);
      //       //     // console.log("Found meeting type ID");
      //       //     i++;
      //       //   }
      //       });
      //       $("#processTablePopup").DataTable().destroy();
      //      this. processes=[]
      //       console.log('process data---->>',processData);
      //       this.processes =processData;
      //       // for (var j = 0; j < this.addedProcess.length; j++) {
      //       //   var index = this.indexOfElementArray(this.processes, this.addedProcess[j]);
      //       //   // console.log(index);
      //       //   this.processes.splice(index, 1);
      //       // }

      //       // console.log(this.processes)
      //       // this.dtTriggerForAddedProcess.next();
      //       this.dtTriggerProcessAddingPopup.next();
      //     }
      //   })
    }
  }

  getProcessList() {
    // this.processes = [];

    // $("processTablePopup").DataTable().destroy();
    // this.processMasterService.getProcessList()
    //   .subscribe(processList => {
    //     if (processList.status == 0) {
    //       this.processes = processList.processList;
    //       this.processes.forEach(element => {
    //         element.IsSelected = false;
    //         if (element.MeetingTypeId == this.meetingTypeID) {
    //           // console.log("Found meeting type ID");
    //         }
    //       });
    //       // console.log(this.processes)
    //       // this.dtTriggerForAddedProcess.next();
    //       this.dtTriggerProcessAddingPopup.next();
    //     }
    //   })
    this.onAddProcessModelPopUpEvent()
  }

  indexOfElementArray(array: any[], elementValue) {
    var index = _.findIndex(array, function (o) {

      if (o._id == elementValue._id) { console.log('found element', o); }
      return o._id == elementValue._id;
    })
    return index;
  }


  addProcessToAgendaForm() {
    this.disabledOnclick = false;
    var table = $('#processTablePopup').DataTable({ destroy: true });
    table.destroy();
    var table2 = $('#processTable').DataTable({ destroy: true });
    table2.destroy();
    var checkedProcesses = this.processes.filter(opt => opt.IsSelected).map(opt => opt);
    // console.log(checkedProcesses);
    var addedProcess = this.addedProcess;
    var allProcess = this.processes;

    // console.log( this.processes);
    // this.addedProcess = [];
    for (var j = 0; j < checkedProcesses.length; j++) {
      checkedProcesses[j].IsNew = true;
      var index = this.indexOfElementArray(allProcess, checkedProcesses[j]);
      // console.log(index);
      allProcess.splice(index, 1);
    }


    // for(var i=0;i<allProcess.length;i++){
    //   var addedBoolean=false;
    //   for(var j=0;j<checkedProcesses.length;j++){

    //     if(allProcess[i]._id==checkedProcesses[j]._id){
    //       console.log(allProcess[i]._id);
    //       console.log(checkedProcesses[j]._id);
    //       addedBoolean=true;
    //       break;
    //     }

    //   }
    //   if(addedBoolean){
    //     //remove index i from processes
    //     allProcess.splice(i,1);
    //   }
    // }
    this.addedProcess = [];
    this.processes = [];
    this.addedProcess = addedProcess.concat(checkedProcesses);
    this.processes = allProcess;
    this.dtTriggerProcessAddingPopup.next();
    this.dtTriggerForAddedProcess.next();
    $('#AddProcessDialog').modal('toggle');
  }

  isProcessSelected: boolean;


  selectAllProcess(ev) {
    if (ev.target.checked == true) {

      this.processes.forEach(element => {
        element.IsSelected = true;
      });
    } else {
      this.processes.forEach(element => {
        element.IsSelected = false;
      });
    }
  }

  checkProcessselected(event) {
    // console.log(event.target);
    if (event.target.checked == true) {
      //console.log(event.target);
      this.isProcessSelected = true;
    }
    else {
      this.isProcessSelected = false;
    }
  }

  onPopupAddProcessEvent() {
    this.showAllProcesses()
    setTimeout(function () {
      $("#processTablePopup").DataTable().columns.adjust();
    }, 500);
  }


  removeProcess(process_id) {

    if (_.size(this.deletedProcesses)) {
      this.deletedProcesses.push(process_id);
    } else {
      this.deletedProcesses = [];
      this.deletedProcesses.push(process_id);
    }


    var addedData = [];
    addedData = this.addedProcess;
    this.addedProcess = [];
    $("#processTable").DataTable().destroy();
    var index = this.indexOfProcessArray(addedData, process_id);
    addedData.splice(index, 1);
    this.addedProcess = addedData;
    this.dtTriggerForAddedProcess.next();
  }


  indexOfProcessArray(array: any[], process_id) {
    var index = _.findIndex(array, function (o) {
      if (o._id == process_id) { console.log('found element', o); }
      return o._id == process_id;
    })
    return index;
  }

  // this. addedProcess = [];
  // $("#processTable").DataTable().destroy();
  // this.agendaService.deleteProcessFromAgenda(process_id,this.agendaId)
  //   .subscribe(result => {
  //     console.log(result);
  //     if (result.status == 0) {
  //      console.log(result);
  //       this. addedProcess =result.Agendaresult;
  //       this.dtTriggerForAddedProcess.next();
  //     }
  //   });

  // checkProcessselected(event){
  //   console.log(event.target);
  //   if (event.target.checked == true) {
  //     console.log(event.target);
  //     this.isProcessSelected = true;
  //   }
  //   else {
  //     this.isProcessSelected = false;
  //   }
  // }
  processType: any;
  SearchprocessUserdefinedorPredefinedModel: any;

  CheckProcessType(item: any) {
    this.processType = item;
    this.getProcessListByProcessType(this.processType);

  }
  getProcessListByProcessType(processType) {
    this.processes = [];
    // if (this.dtElement.dtInstance != undefined) {
    //   this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
    //     dtInstance.destroy();
    //   });
    // }
    $("#processTablePopup").DataTable().destroy();

    var ispredefined = null;
    if (processType === 'Predefined') {
      ispredefined = true;
    } else if (processType === 'Userdefined') {
      ispredefined = false;
    }

    console.log('ispredefined----->>>>', ispredefined);
    this.processMasterService.getProcessList()
      .subscribe(processList => {
        if (processList.status == 0) {
          var data = [];
          var processData = processList.processList;//$(processList.processList).filter(function (i, n) { return n.IsPredefined === ispredefined });
          for (var i = 0; i < processData.length; i++) {

            if (processData[i].MeetingTypeId != this.meetingTypeID && processData[i].IsPredefined == ispredefined) {
              processData[i].IsSelected = false;
              console.log(processData[i].IsPredefined);
              data.push(processData[i]);
            }

          }
          this.processes = data;
          this.dtTriggerProcessAddingPopup.next();
        }
      })
  }
  showAllProcesses() {
    this.onAddProcessModelPopUpEvent();
    this.SearchprocessUserdefinedorPredefinedModel = null;
  }

  getGroupIndex() {
    this.agendaService.getGroupIndex().subscribe(data => {
      console.log('data', data)

      if (data.status == 0) {
        this.indexGroupingList = data.data
      }
    });
  }

  getAgendaType() {
    this.agendaService.getAgendaTypeSearch(this.agendaAddForm.controls.agendaType.value).subscribe((agendaDetails:any) => {
      this.agendaTypeOption = [];
      if (agendaDetails.status == 0) {
        this.agendaTypeOption = agendaDetails.TotalTypes;
      }
    });
  }

  showAddPopUpAgendaType(){
    this.agendaNameFieldTouched = false;

  }

  getDepartment() {
    this.branchAndDepartmentService.getDepartment().subscribe((response:any) => {
      if (response.status == 0) {
        this.departmentList = response.data;
      }
    })
  }
  SaveIndexGrouping() {
    this.disabledOnclick = true;
    console.log('oooo0000', this.GroupingIndex,
      this.GroupingName, this.GroupingNumber
    )
    var IsGlobal;
    if (this.GroupingIndex == 'GlobalGroup') {
      IsGlobal = true;
    } else {
      IsGlobal = false;
    }

    var data = {
      'IsGlobal': IsGlobal,
      'GroupingName': this.GroupingName,
      'GroupingNumber': this.GroupingNumber
    }

    this.agendaService.addGroupIndex(data).subscribe(data => {
      this.disabledOnclick = false;
      if (data.status == 0) {
        $("#indexGrouping .close").click();
        this.GroupingIndex = undefined;
        this.GroupingName = undefined;
        this.GroupingNumber = undefined;
        this.alert.success('Group added successfully');
        $("#groupTable").DataTable().destroy();
        // this.GroupingNumberTouched = false;
        // this.GroupingNameTouched = false;
      } else {
        if (data.error.name == "ValidationError") {
          this.alert.error(data.error.message);
        } else {
          this.alert.error('something went wrong.');
        }
      }
      this.getGroupIndex();
      console.log('data', data)
    });

  }

  setGroupingType(typeOfGroup) {
    console.log('typeOfGroup', typeOfGroup)
    this.GroupingIndex = typeOfGroup;
  }

  changeGroup(event) {
    console.log(event);
    var groupData = _.filter(this.indexGroupingList, function (obj) { return obj._id == event.target.value });
    console.log(groupData);
    this.groupName = groupData[0].GroupName;
    this.groupNumber = groupData[0].GroupingNumber;
    this.agendaAddForm.controls.indexGrouping_id.setValue(groupData[0]._id);
  }

  changeDepartment(event) {
    console.log(event);
    // this.agendaAddForm.controls.meeting.setValue(null);
    var groupData = _.filter(this.departmentList, function (obj) { return obj._id == event.target.value });
    console.log(groupData);
    this.groupName = groupData[0].GroupName;
    this.groupNumber = groupData[0].GroupingNumber;
    this.agendaAddForm.controls.department.setValue(groupData[0]._id);
  }

  noBlankSpaceAtStart(ev) {
    if (ev.which === 32 && ev.target.selectionStart === 0) {
      return false;
    }
  }

  groupingNumberFieldTouched() {
    this.GroupingNumberTouched = true;
  }

  groupingNameFieldTouched() {
    this.GroupingNameTouched = true;
  }

  checkedCompanyNameData(event, value) {
    if (event.target.checked) {
      this.pushCompanyDataId.push(value);
    }
    if (!event.target.checked) {
      let index = this.pushCompanyDataId.indexOf(value);
      if (index > -1) {
        this.pushCompanyDataId.splice(index, 1);
      }
    }
    console.log("Company Id array => " + JSON.stringify(this.pushCompanyDataId));
    if (this.pushCompanyDataId.length > 0) {
      this.uploadAgendaDocFileBtn = false;
    } else {
      this.uploadAgendaDocFileBtn = true;
    }
  }
}